import { ErrorResponse, FgStatusEnum, GlobalVariableValues, GradeInvStatusEnum, HarvestTypes, JobCompletedEnum, JobStatusEnum, OperationTypeEnum, OpertionTypeDropDown, ShiftsEnum } from '@gtpl/shared-models/common-models';
import { AssignGradingResponse, CommonResponse, GradeLotInvModel, GradeLotInvResponse, GradeLotNoModel, GradeLotNoResponse, GradingDashboardModel, GradingDashboardResponse, GradingInventoryModel, GradingInventoryResponse, GradingModel, LotCodeDropDown, LotCodesResponse, YieldReportModel, CountQuantityModel, YieldPerReq, BillNumberRequest } from '@gtpl/shared-models/production-management';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
import { WorkStations } from '../workstations/workstations.entity';
import { AssignSoDto } from './dto/assign-so.dto';
import { GradeLotNoRequest } from './dto/grade-lot-no.request';
import { GradeReportingDto } from './dto/grade-reporting.dto';
import { ProductionInventoryData } from './dto/production-inventory.dto';
import { UnitRequest } from './dto/unit.id.request';
import { GradeInventoryLog } from './entities/grade-inventory-log';
import { GradeInventory } from './entities/grade-inventory.entity';
import { ProductionInventory } from './entities/production-inventory.entity';
import { ProductionLog } from './entities/production-log.entity';
import { ProductionLogService } from './production-log.service';
import { GradeInventoryLogRepository } from './repositories/grade-inventory-log.repository';
import { GradeInventoryRepository } from './repositories/grade-inventory.repository';
import { LotCodeOpsRepository } from './repositories/lot-code.repository';
import { ProductionInventoryRepository } from './repositories/production-inventory.repository';
import { ProductionLogRepository } from './repositories/production-log.repository';
import { WorkstationsService } from '../workstations/workstations.service';
import { WorkstationRequest } from '../workstations/dto/workstation.request';
import { NODATA } from 'dns';
import { VariantOperationsService } from '../variant-operations/variant-operations.service';
import { SaleOrderService } from '@gtpl/shared-services/sale-management';
import { VariantNextOpModel } from '../variant-operations/dto/variant-next-op.model';
import { getConnection, getManager, In, IsNull, MoreThan, Not, QueryRunner } from 'typeorm';
import { UnitcodeService } from '@gtpl/shared-services/masters';
import { IndentService, RmCountPriceListService, RMGrnService } from '@gtpl/shared-services/raw-material-procurement';
import { FactoriesInput } from '@gtpl/shared-models/sale-management';
import appSettings from 'apps/services/config';
import { PlantIdRequest, UnitTypeEnum } from '@gtpl/shared-models/masters';
import { IsNotIn } from 'class-validator';
import { ProductReq } from '@gtpl/shared-models/analytics-data'

import { CompanyCategoryEnum, RmRatesInfoReq } from '@gtpl/shared-models/raw-material-procurement';
import { ProductionLogRequest } from 'libs/shared-models/production-management/src/lib/production-inv/production-log.req';
import { LotCodeOpsEntity } from './entities/lot-code.entity';
import moment from 'moment';
@Injectable()
export class GradeInventoryService {
    constructor(@InjectRepository(ProductionInventoryRepository)
    private inventoryRepository: ProductionInventoryRepository,
    @InjectRepository(GradeInventoryRepository)
    private gradeInventoryRepository: GradeInventoryRepository,
    @InjectRepository(LotCodeOpsRepository)
    private lotCodeOpsRepository: LotCodeOpsRepository,
    @InjectRepository(ProductionLogRepository)
    private logRepository: ProductionLogRepository,
    private unitCodesService: UnitcodeService,
    private workstationService: WorkstationsService,    
    private variantOperationService: VariantOperationsService,
    private saleService: SaleOrderService,
    private indentService: IndentService,
    private rmGrnService :RMGrnService,
    private rmCountPriceListService : RmCountPriceListService
    ){ }
    

    async assignGradingOperation(inputReq: ProductionInventoryData): Promise<AssignGradingResponse> {
        const manager = new GenericTransactionManager();
        try {
            const result =await this.unitCodesService.getPlantDetailsById(new PlantIdRequest(inputReq.plantId))
            let columnName ;
            let productionInventoryData
            if(result.data.plantType==UnitTypeEnum.SUB_PLANT){
                columnName = 'subPlantId'
                productionInventoryData = await this.inventoryRepository.findOne({ where: { lotNumber: inputReq.lotNumber, saleOrderId: inputReq.saleOrderId, saleOrderItemId: inputReq.saleOrderItemId, operation: OperationTypeEnum.GRADING, subPlantId: inputReq.plantId } });
            }else{
                columnName = 'plantId'
                productionInventoryData = await this.inventoryRepository.findOne({ where: { lotNumber: inputReq.lotNumber, saleOrderId: inputReq.saleOrderId, saleOrderItemId: inputReq.saleOrderItemId, operation: OperationTypeEnum.GRADING, plantId: inputReq.plantId,subPlantId:0 } });
            }


            let prodInvResponse;
            let productioninvId
            inputReq.ipBoxes = inputReq.boxes;
            inputReq.wipQuantity = inputReq.physicalQuantity;
            inputReq.operation = OperationTypeEnum.GRADING;
            inputReq.subLotNumber = inputReq.lotNumber;
            await manager.startTransaction();
            if (productionInventoryData) {
                prodInvResponse = await manager.getCustomRepository(ProductionInventoryRepository).updateInventoryQuantity(inputReq,columnName);
                productioninvId = productionInventoryData.productionInventoryId
            } else {
                const prodInv = new ProductionInventory();
                prodInv.lotNumber = inputReq.lotNumber;
                prodInv.createdUser = inputReq.createdUser;
                prodInv.subLotNumber = inputReq.lotNumber;
                prodInv.saleOrderId = inputReq.saleOrderId;
                prodInv.saleOrderItemId = inputReq.saleOrderItemId;
                prodInv.operation = OperationTypeEnum.GRADING;
                // prodInv.nextOperation = OperationTypeEnum.VALUE_ADDITION;
                prodInv.wipQuantity = inputReq.physicalQuantity;
                prodInv.inputGrade = String(inputReq.inputGrade);
                prodInv.boxes = inputReq.boxes;
                if(result.data.plantType == UnitTypeEnum.PLANT){
                    prodInv.subPlantId = 0;
                    prodInv.plantId = inputReq.plantId;
                }
                if(result.data.plantType == UnitTypeEnum.SUB_PLANT){
                    prodInv.subPlantId = inputReq.plantId;
                    prodInv.plantId = inputReq.mainPlantId;

                }
                // prodInv.plantId = inputReq.plantId;
                // if (inputReq.subPlantId) {
                //     prodInv.subPlantId = inputReq.subPlantId;
                // }
                prodInvResponse = await manager.getCustomRepository(ProductionInventoryRepository).save(prodInv);
                productioninvId = prodInvResponse.productionInventoryId
            }
            if (prodInvResponse) {
                
                const productionLogObj = new ProductionLog();
                productionLogObj.lotNumber = inputReq.lotNumber;
                productionLogObj.subLotNumber = inputReq.lotNumber;
                productionLogObj.saleOrderId = inputReq.saleOrderId;
                productionLogObj.saleOrderItemId = inputReq.saleOrderItemId;
                productionLogObj.operationType = OperationTypeEnum.GRADING;
                // job number generation 
                let today = new Date();
                let CurrentYear = today.getFullYear();
                let CurrentMonth = today.getMonth();
                let fromDate = 0;
                let toDate = 0;
                let totalRecords = await (await this.logRepository.find({where:{operationType:OperationTypeEnum.GRADING}})).length;
                    if ((CurrentMonth+1) < 4) {
                        fromDate = (CurrentYear-1);
                        toDate = (CurrentYear);
                    } else {
                        fromDate = (CurrentYear);
                        toDate = (CurrentYear + 1);
                    }

                totalRecords = totalRecords + 1;

                var refNo = totalRecords + "";
                while (refNo.length < 4) refNo = "0" + refNo;

                const GradingJobNo = "Grading/" + (fromDate.toString().substr(-2))+"-"+(toDate.toString().substr(-2)) + "/" + refNo;

                productionLogObj.jobNumber = GradingJobNo;
                // productionLogObj.plantId = inputReq.plantId;
                // if (inputReq.subPlantId) {
                    //     productionLogObj.subPlantId = inputReq.subPlantId;
                    // }
                //subplant wise grading operation logic
                if(result.data.plantType == UnitTypeEnum.PLANT){
                    productionLogObj.subPlantId = 0;
                    productionLogObj.plantId = inputReq.plantId;
                }
                if(result.data.plantType == UnitTypeEnum.SUB_PLANT){
                    productionLogObj.subPlantId = inputReq.plantId;
                    productionLogObj.plantId = inputReq.mainPlantId;
                }
                productionLogObj.workStationType = inputReq.workStationType;
                productionLogObj.workstation = new WorkStations();
                productionLogObj.workstation.workstationId = inputReq.workstation;
                productionLogObj.jobStatus = JobCompletedEnum.NO;
                productionLogObj.inputGrade = String(inputReq.inputGrade);
                productionLogObj.inputQuantity = inputReq.physicalQuantity;
                productionLogObj.inputBoxes = inputReq.boxes;
                productionLogObj.assignedUser = inputReq.createdUser;//need to get assigned user
                productionLogObj.shift = inputReq.shift;
                productionLogObj.createdUser = inputReq.createdUser;
                productionLogObj.prodInvId = productioninvId;
                productionLogObj.assignedTime = inputReq.assignedTime;
                const saveProdLog = await manager.getCustomRepository(ProductionLogRepository).save(productionLogObj);
                const updatePrevOPQty = await manager.getCustomRepository(ProductionInventoryRepository).updateInventoryIssuedQuantity(inputReq.lotNumber,inputReq.lotNumber,inputReq.saleOrderId,inputReq.saleOrderItemId,inputReq.productionInventoryId,inputReq.plantId,inputReq.physicalQuantity);
                if (saveProdLog && updatePrevOPQty) {
                    manager.completeTransaction();
                    return new AssignGradingResponse(true, 5555, 'Work station allocated and material assigned to grading', true)
                } else {
                    await manager.releaseTransaction();
                    return new AssignGradingResponse(false, 9999, 'some thing went wrong', false)
                }
            }else{
                await manager.releaseTransaction();
                throw new ErrorResponse(9999, 'Failed To allocate to workstation')
            }

        } catch (error) {
            await manager.releaseTransaction();
            throw error;
        }
    }


    /**
     * This service will get lot level count,weight and grade counts and boxes
     * @param inputReq 
     */
    async getLotLevelInfoForGrading(inputReq: GradeLotNoRequest): Promise<GradeLotNoResponse> {
        const manager = getManager()
        let count = 0;
        let saleOrderNumber = '';
        let currentWeight = 0;
        let wipWeight = 0;
        let prevOpWeight = 0;
        let mainPlantId = 0;
        const gradeCounts:GradingModel[] = [];    
        let rmInvResult   
        // get lot head on count
        //sub plant wise data fetching logic
        const result =await this.unitCodesService.getPlantDetailsById(new PlantIdRequest(inputReq.plantId))
        // if(result.data.plantType==UnitTypeEnum.SUB_PLANT){
        //     rmInvResult = await this.lotCodeOpsRepository.findOne({select:["count","saleOrderId","saleOrderItemId"],where:{lotNumber: inputReq.lotNo}});
        // }else{
            rmInvResult = await this.lotCodeOpsRepository.findOne({select:["count","saleOrderId","saleOrderItemId","quantity"],where:{lotNumber: inputReq.lotNo,year:inputReq.year}});
            // console.log(rmInvResult,'rmInvResult')
        // }
        if(rmInvResult){
            count = rmInvResult.count;
            saleOrderNumber = await (await this.saleService.getSaleOrderDataForSoId({saleOrderId: rmInvResult.saleOrderId})).saleOrderNumber;
        }
        // const getHonQuantity = await this.inventoryRepository.find({where:{operation:OperationTypeEnum.GRN,lotNumber:inputReq.lotNo},select:['physicalQuantity']})
        const getHonQuantityQry = `SELECT SUM(quantity) AS qty FROM ${appSettings.production_db} .lot_code_data WHERE IF(lot_club_status = 1, clubbed_main_lot IN ('${inputReq.lotNo}') , lot_number IN ('${inputReq.lotNo}')) AND year = ${inputReq.year}`
        const getHonQuantity = await manager.query(getHonQuantityQry)
        // console.log(getHonQuantity,'getHonQuantity')
        // get production inventory details
        let prodInvRecord
        let prevOpWeigntData
        if(result.data.plantType==UnitTypeEnum.SUB_PLANT){
            prodInvRecord = await this.inventoryRepository.findOne({select:["wipQuantity","plantId"],where:{
                lotNumber:inputReq.lotNo,year:inputReq.year,saleOrderId:rmInvResult.saleOrderId,saleOrderItemId:rmInvResult.saleOrderItemId,operation:OperationTypeEnum.GRADING,subPlantId:inputReq.plantId
            }});
            prevOpWeigntData = await this.inventoryRepository.findOne({select:["issuedQuantity","plantId"],where:{
                lotNumber:inputReq.lotNo,year:inputReq.year,saleOrderId:rmInvResult.saleOrderId,saleOrderItemId:rmInvResult.saleOrderItemId,nextOperation:OperationTypeEnum.GRADING,subPlantId:inputReq.plantId
            }});
        }else{
            prodInvRecord = await this.inventoryRepository.findOne({select:["wipQuantity","plantId"],where:{
                lotNumber:inputReq.lotNo,year:inputReq.year,saleOrderId:rmInvResult.saleOrderId,saleOrderItemId:rmInvResult.saleOrderItemId,operation:OperationTypeEnum.GRADING,plantId:inputReq.plantId,subPlantId:0
            }});
            prevOpWeigntData = await this.inventoryRepository.findOne({select:["issuedQuantity","plantId"],where:{
                lotNumber:inputReq.lotNo,year:inputReq.year,saleOrderId:rmInvResult.saleOrderId,saleOrderItemId:rmInvResult.saleOrderItemId,nextOperation:OperationTypeEnum.GRADING,plantId:inputReq.plantId,subPlantId:0
            }});
        }

        if(prodInvRecord){
            wipWeight = prodInvRecord.wipQuantity;
            prevOpWeight = prevOpWeigntData.issuedQuantity;
            mainPlantId = prodInvRecord.plantId
        }

        let prodInvLogRecord
        if(result.data.plantType==UnitTypeEnum.SUB_PLANT){
            prodInvLogRecord = await this.logRepository.createQueryBuilder('prod_log')
            .select('workstation_type,workstation_id')
            .leftJoin('prod_log.workstation','workstation')
            .where(`prod_log.lot_number='${inputReq.lotNo}' and prod_log.year=${inputReq.year} and sale_order_id=${rmInvResult.saleOrderId} and sale_order_item_id=${rmInvResult.saleOrderItemId} and operation='${OperationTypeEnum.GRADING}'  and sub_plant_id=${inputReq.plantId} and prod_log.workstation is not null`)
            .getRawOne();
        }else{
            prodInvLogRecord = await this.logRepository.createQueryBuilder('prod_log')
            .select('workstation_type,workstation_id')
            .leftJoin('prod_log.workstation','workstation')
            .where(`prod_log.lot_number='${inputReq.lotNo}' and prod_log.year=${inputReq.year} and sale_order_id=${rmInvResult.saleOrderId} and sale_order_item_id=${rmInvResult.saleOrderItemId} and operation='${OperationTypeEnum.GRADING}'  and plant_id=${inputReq.plantId} and sub_plant_id = 0 and prod_log.workstation is not null`)
            .getRawOne();
        }

        // get lot level grade head less counts and boxes and its weight
        let gradeInventoryResult
        if(result.data.plantType==UnitTypeEnum.SUB_PLANT){
            gradeInventoryResult = await this.gradeInventoryRepository.find({select:["grade","boxes","quantity","gradeInvId"],where:{subPlantId: inputReq.plantId,lotNumber: inputReq.lotNo,year:inputReq.year}});
        }else{
            gradeInventoryResult = await this.gradeInventoryRepository.find({select:["grade","boxes","quantity","gradeInvId"],where:{plantId: inputReq.plantId,subPlantId:0,lotNumber: inputReq.lotNo,year:inputReq.year}});
        }
        if(gradeInventoryResult.length > 0){
            for(const gradeCount of gradeInventoryResult){
                gradeCounts.push(new GradingModel(Number(gradeCount.grade),gradeCount.boxes,0,gradeCount.boxes,gradeCount.quantity,'',gradeCount.gradeInvId));
                currentWeight+=Number(gradeCount.quantity);
            }
        }
        return new GradeLotNoResponse(true,10000,'Lot Info Retrieved Successfully',new GradeLotNoModel(Number(count),currentWeight.toString(),gradeCounts,saleOrderNumber,prodInvLogRecord?.workstation_type,prodInvLogRecord?.workstation_id,prevOpWeight,mainPlantId,getHonQuantity[0].qty));
    }

    /**
     * save data into grade inv log and grade inventory tables
     * @param inputReq 
     */
    async saveCountInGradeInventory(inputReq: GradeReportingDto): Promise<CommonResponse> {
        const manager = new GenericTransactionManager();
        const result =await this.unitCodesService.getPlantDetailsById(new PlantIdRequest(inputReq.plantId))
        const inv:GradeInventory[] = [];
        const invLog:GradeInventoryLog[] = [];
        if(inputReq.grades.length === 0) {
            throw new ErrorResponse(10000,'Count ann boxes should not be empty');
        }        
        inputReq.grades.map(count => {
            if(count.boxes>0){
                const gradeInvLog = new GradeInventoryLog();
                //plant and subplant wise data saving
                if(result.data.plantType == UnitTypeEnum.PLANT){
                    gradeInvLog.subPlantId = 0;
                    gradeInvLog.plantId = inputReq.plantId;
                }
                if(result.data.plantType == UnitTypeEnum.SUB_PLANT){
                    gradeInvLog.subPlantId = inputReq.plantId;
                    gradeInvLog.plantId = inputReq.mainPlantId;

                }
                // gradeInvLog.plantId = inputReq.plantId;
                gradeInvLog.shift = ShiftsEnum[inputReq.shift];
                gradeInvLog.workStationType = inputReq.workstationType;
                gradeInvLog.workstation = inputReq.workstation;
                gradeInvLog.lotNumber = inputReq.lotNo;
                gradeInvLog.grade = count.grade;
                gradeInvLog.boxes = count.boxes;
                gradeInvLog.createdUser = inputReq.createdUser;
                gradeInvLog.quantity = count.quantity;
                gradeInvLog.quantityType = GradeInvStatusEnum.REPORTED;
                invLog.push(gradeInvLog);
            }            
        });
        await manager.startTransaction();
        const gradeInvLog:GradeInventoryLog[] = await manager.getCustomRepository(GradeInventoryLogRepository).save(invLog);
        if(gradeInvLog.length === 0) { 
            await manager.releaseTransaction();    
            throw new ErrorResponse(10000,'Operation reporting failed/add boxes and grade to report');
        }
        for(const logRecord of gradeInvLog){
            const gradeInv = await this.gradeInventoryRepository.findOne({lotNumber:logRecord.lotNumber,grade:logRecord.grade});
            if(gradeInv) {
                gradeInv.boxes += logRecord.boxes;
                gradeInv.quantity = Number(gradeInv.quantity)+Number(logRecord.quantity);
                gradeInv.updatedUser = inputReq.createdUser; 
                gradeInv.plannedSoNumber = inputReq.soNumber;
                inv.push(gradeInv);
            } else {
                const gradeInvObj = new GradeInventory();
                //plnat and subplant wise data saving
                if(result.data.plantType == UnitTypeEnum.PLANT){
                    gradeInvObj.subPlantId = 0;
                    gradeInvObj.plantId = inputReq.plantId;
                }
                if(result.data.plantType == UnitTypeEnum.SUB_PLANT){
                    gradeInvObj.subPlantId = inputReq.plantId;
                    gradeInvObj.plantId = inputReq.mainPlantId;

                }
                // gradeInvObj.plantId = inputReq.plantId;
                gradeInvObj.lotNumber = inputReq.lotNo;
                gradeInvObj.grade = logRecord.grade;
                gradeInvObj.boxes = logRecord.boxes;
                gradeInvObj.quantity = logRecord.quantity;
                gradeInvObj.plannedSoNumber = inputReq.soNumber;
                gradeInvObj.createdUser = inputReq.createdUser; 
                inv.push(gradeInvObj);
            }
        }

        const save = await manager.getCustomRepository(GradeInventoryRepository).save(inv);
        const saveFlag = new Set<boolean>()
        if(save){
            const saleOrderInfo = await this.saleService.getDummySo()
            for(const rec of inputReq.grades){
                const req = new AssignSoDto()
                req.lotNo = inputReq.lotNo
                req.createdUser = inputReq.createdUser
                req.plantId = inputReq.plantId
                req.soNumber = saleOrderInfo.data.saleOrderId
                req.soItemNumber = saleOrderInfo.data.soItemId
                req.count = rec.grade
                req.boxes = rec.boxes
                req.quantity = rec.quantity
                req.plannedSoId = saleOrderInfo.data.saleOrderId

                const assignSoSave = await this.assignCountToSO(req,manager) 
                if(!assignSoSave.status){
                    saveFlag.add(false)
                    await manager.releaseTransaction()
                    return new CommonResponse(false,0,'Something went wrong in assigning so')
                }
            }
        }else{
            saveFlag.add(false)
            await manager.releaseTransaction()
            return new CommonResponse(false,0,'Something went wrong in Operation Reporting')
        }
        if(!(saveFlag.has(false))){
            await manager.completeTransaction();
            return new CommonResponse(true,10000,'Operation reported Successfully',true);
        }else{
            await manager.releaseTransaction()
            return new CommonResponse(false,0,'Something went wrong')
        }
    }

    async getAllGrnItemS():Promise<CommonResponse>{
        const manager = getManager();
        const quuery='SELECT remarks as plantLotNumber,lot_number as lotNumber FROM erpx_dev_rm_procurement.grn_items'
        const result = await manager.query(quuery)
        if(result){
            return new CommonResponse(true,1,'dataa',result)
        }else{
            return new CommonResponse(false,0,'not found',[])
        }
    }



     async getLotLevelGradingInventory(inputReq: UnitRequest): Promise<GradeLotInvResponse> {
        // const gradeInv = await this.gradeInventoryRepository.find({plantId: inputReq.unitId});
        // if(gradeInv.length === 0) {
        //     throw new ErrorResponse(10000,'Grading Inventory not found')
        // }
        // const lotGradeInvRecords:GradeLotInvModel[] = [];
        // for(const count of gradeInv) {
        //     lotGradeInvRecords.push(new GradeLotInvModel(count.lotNumber,count.grade,count.quantity,count.issuedQuantity,count.plannedSoNumber));
        // }
        let data1 =[]
                try{
                    const grnItemData = await this.getAllGrnItemS()
                    const grnItemDataeMap = new Map<string, string>();
                    grnItemData.data.forEach(loc => grnItemDataeMap.set(loc.lotNumber, loc.plantLotNumber))
                    const manager = getManager();
                    let query
            const result =await this.unitCodesService.getPlantDetailsById(new PlantIdRequest(inputReq.unitId))
             query=' SELECT u.unit_name as subplantName,uc.unit_name as plantName,grade_inv_id AS GradeInventoryId,g. plant_id AS plantId,g.sub_plant_id AS subplantId, g.lot_number AS lotNumber, g.lot_number AS lotNo,g.grade AS count, g.boxes AS boxes,g.quantity AS quantity,g.issued_quantity AS assignedQty,g.planned_so_number AS plannedSoNumber, sd.po_number AS poNumber,s.sale_order_id as saleOrderId,g.boxes,g.issued_boxes as assignedBoxes,soi.po_number as assignedSO FROM '+appSettings.production_db+'.grade_inventory g  LEFT JOIN '+appSettings.sales_db+'.sale_order s ON g.planned_so_number=s.sale_order_no LEFT JOIN '+appSettings.sales_db+'.so_invoice_details sd ON sd.sale_order_id=s.sale_order_id  left join '+appSettings.masters_db+'.unitcodes uc on uc.unit_code_id=g.plant_id LEFT JOIN '+appSettings.masters_db+'.unitcodes u on u.unit_code_id=g.sub_plant_id  LEFT JOIN '+appSettings.sales_db+'.so_invoice_details soi ON soi.sale_order_id=s.sale_order_id WHERE grade_inv_id > 0 and' 
            //  left join '+appSettings.production_db+'.production_inventory pi on pi.lot_number = g.lot_number and pi.output_grade = g.grade and pi.plant_id = g.plant_id and pi.sub_plant_id = g.sub_plant_id and pi.operation = "'+OperationTypeEnum.GRADING+'" ( production join removed loading issue resolved)
             if(result.data.plantType == UnitTypeEnum.SUB_PLANT){
             query = query +' g.sub_plant_id='+inputReq.unitId+''
             }else{
                query = query +' g.plant_id ='+inputReq.unitId+' '
             }
            const data=await manager.query(query)      
            for(const record of data){
                let plantLot
                plantLot = grnItemDataeMap.get(record.lotNumber)
                if(plantLot == null ){
                    plantLot = record.lotNumber
                }else{
                    plantLot = record.lotNumber+'-'+grnItemDataeMap.get(record.lotNumber)
                }
                data1.push({
                    subplantName:record.subplantName,
                    plantName:record.plantName,
                    GradeInventoryId:record.GradeInventoryId,
                    plantId:record.plantId,
                    subplantId:record.subplantId,
                    lotNumber:record.lotNumber,
                    lotNo:record.lotNo,
                    count:record.count,
                    boxes:record.boxes,
                    quantity:record.quantity,
                    assignedQty:record.assignedQty,
                    plannedSoNumber:record.plannedSoNumber,
                    poNumber:record.poNumber,
                    saleOrderId:record.saleOrderId,
                    assignedBoxes:record.assignedBoxes,
                    assignedSO:record.assignedSO,
                    lotnplantlot:plantLot
                })
            }
        
            if(data1.length > 0){
                return new GradeLotInvResponse(true,1001,"Grading Inventory Retrieved Successfully",data1);
              }
              else{
                return new GradeLotInvResponse(false,1010,"No data found. ",data1);
              }
        }
        catch(err){
            return err
          }
        // return new GradeLotInvResponse(true,10000,'Grading Inventory Retrieved Successfully',lotGradeInvRecords);
    }


    /**
     * assign count to SO
     * @param inputReq 
     */
     async assignCountToSO(inputReq: AssignSoDto,manager?:GenericTransactionManager): Promise<CommonResponse> { 
        // const manager = new GenericTransactionManager();   
        // try{
            //check if same SO and Lot existed with another count
            const existingGradesdata = await this.inventoryRepository.find({where:{lotNumber:inputReq.lotNo,saleOrderId:inputReq.soNumber,saleOrderItemId:inputReq.soItemNumber,operation:OperationTypeEnum.GRADING,inputGrade:Not(In([0,inputReq.count]))}})
            console.log(existingGradesdata,'existingGradesdata')
            if(existingGradesdata.length > 0){
                throw new ErrorResponse(10000,'Same Lot should not contain different grdaes with Same Saleorder');
            }
           
            // Getting variant information for so item id
            const variantInfo = await this.saleService.getVarientInfoForSoItem({saleOrderItemId: inputReq.soItemNumber});
            if(!variantInfo.status){
                throw new ErrorResponse(10000,'Variant information not found');
            }       
            // get next operation for current operation by varaint id
            const nextOperation = await this.variantOperationService.getNextOperationForVariantId(new VariantNextOpModel(OperationTypeEnum.GRADING,variantInfo.data.variantId,inputReq.plantId));
            // await manager.startTransaction();
            // insert into garding inv log
            const gradeInvLogObj = await manager.getCustomRepository(GradeInventoryLogRepository).findOne({lotNumber:inputReq.lotNo,grade:inputReq.count,quantityType: GradeInvStatusEnum.REPORTED });

            //getting workstation capacity        
            const capacityResp = await this.workstationService.getCapacityForPlantAndWorkstation(new WorkstationRequest(gradeInvLogObj.workstation,inputReq.plantId));

            const capacity = capacityResp.data;
            const boxes = Math.ceil(inputReq.quantity/capacity);

            const gradeInvLog = new GradeInventoryLog();
            //plant and subplant wise data saving

            gradeInvLog.plantId = gradeInvLogObj.plantId;
            gradeInvLog.subPlantId = gradeInvLogObj.subPlantId;
            gradeInvLog.shift = gradeInvLogObj.shift;
            gradeInvLog.workStationType = gradeInvLogObj.workStationType;
            gradeInvLog.workstation = gradeInvLogObj.workstation;
            gradeInvLog.lotNumber = inputReq.lotNo;
            gradeInvLog.grade = inputReq.count;
            gradeInvLog.boxes = inputReq.boxes;
            gradeInvLog.createdUser = inputReq.createdUser;
            gradeInvLog.quantity = inputReq.quantity;
            gradeInvLog.quantityType = GradeInvStatusEnum.ASSIGNED;
            gradeInvLog.saleOrderId = inputReq.soNumber;
            gradeInvLog.saleOrderItemId = inputReq.soItemNumber;
            await manager.getCustomRepository(GradeInventoryLogRepository).save(gradeInvLog);
            // update grading inv
            const gradeInvObj = await manager.getCustomRepository(GradeInventoryRepository).findOne({lotNumber:inputReq.lotNo,grade:inputReq.count});
            gradeInvObj.issuedQuantity = Number(gradeInvObj.issuedQuantity) + Number(inputReq.quantity);
            gradeInvObj.issuedBoxes = Number(gradeInvObj.issuedBoxes) + Number(inputReq.boxes);
            gradeInvObj.updatedUser = inputReq.createdUser;
            if(Number(gradeInvObj.issuedQuantity)>Number(gradeInvObj.quantity) || Number(gradeInvObj.issuedQuantity)>Number(gradeInvObj.quantity)){
                await manager.releaseTransaction();
                throw new ErrorResponse(10000,'Issued quantity cannot exceed original quantity');
            }        
            await manager.getCustomRepository(GradeInventoryRepository).save(gradeInvObj);

            // Get So Related Information
            const soInfo = await this.saleService.getPoNumberForSoId({saleOrderId:inputReq.soNumber});
            if(!soInfo && soInfo.data.saleOrderId === null){
                await manager.releaseTransaction();
                throw new ErrorResponse(10000,'Sale order not found!!!');
            }            
            const subLotNumber = inputReq.lotNo+'-'+soInfo.data.SoInvDetailsInfo.poNumber+'-'+inputReq.count+'-'+variantInfo.data.variantCode;
            const prodInvObj = await manager.getCustomRepository(ProductionInventoryRepository).findOne({lotNumber:inputReq.lotNo,saleOrderId:inputReq.soNumber,saleOrderItemId:inputReq.soItemNumber,operation:OperationTypeEnum.GRADING,plantId:inputReq.plantId,subPlantId:gradeInvLogObj.subPlantId})
            console.log(prodInvObj,'prodInvObj')
            let prodInvId
            const WIPupdate = await manager.getCustomRepository(ProductionInventoryRepository).update({lotNumber: inputReq.lotNo, saleOrderId: inputReq.plannedSoId, operation: OperationTypeEnum.GRADING, plantId: gradeInvLogObj.plantId,subPlantId:gradeInvLogObj.subPlantId},{wipQuantity: ()=>`wip_quantity-${inputReq.quantity}`})
            if(prodInvObj){
                // Update data in production inventory        
                const prodInvResponse = await manager.getCustomRepository(ProductionInventoryRepository).update({lotNumber: inputReq.lotNo, saleOrderId: inputReq.soNumber, saleOrderItemId: inputReq.soItemNumber, operation: OperationTypeEnum.GRADING, plantId: gradeInvLogObj.plantId,subPlantId:gradeInvLogObj.subPlantId}, {subLotNumber:subLotNumber,nextOperation:nextOperation,inputGrade:String(inputReq.count),outputGrade:String(inputReq.count),physicalQuantity:()=>`physical_quantity+${inputReq.quantity}`,updatedUser:inputReq.createdUser,opBoxes: ()=>`op_boxes+${inputReq.boxes}`});
                prodInvId = prodInvObj.productionInventoryId
                if(!(prodInvResponse.affected)){
                    await manager.releaseTransaction();
                    throw new ErrorResponse(10000,'something went wrong in operation update');
                }
            }else{
                // create production inventory record
                const prodInv = new ProductionInventory();
                prodInv.lotNumber = inputReq.lotNo;
                prodInv.createdUser = inputReq.createdUser;
                prodInv.subLotNumber = subLotNumber;
                prodInv.saleOrderId = inputReq.soNumber;
                prodInv.saleOrderItemId = inputReq.soItemNumber;
                prodInv.operation = OperationTypeEnum.GRADING;
                prodInv.nextOperation = nextOperation;
                prodInv.inputGrade = String(inputReq.count);
                prodInv.outputGrade = String(inputReq.count);
                prodInv.physicalQuantity = inputReq.quantity;
                prodInv.boxes = 0;
                prodInv.opBoxes = inputReq.boxes;
                prodInv.plantId = gradeInvLogObj.plantId;
                prodInv.subPlantId = gradeInvLogObj.subPlantId;
                prodInv.status = FgStatusEnum.IN_PROGRESS;
                prodInv.updatedUser = inputReq.createdUser;
                const prodInvResponse = await manager.getCustomRepository(ProductionInventoryRepository).save(prodInv);
                prodInvId = prodInvResponse.productionInventoryId
                if(!prodInvResponse){
                    await manager.releaseTransaction();
                    throw new ErrorResponse(10000,'something went wrong in operation update');
                }
            }
            // validate if sale order details are avaialbe or not
            const prodInvLogObj = await manager.getCustomRepository(ProductionLogRepository).find({lotNumber: inputReq.lotNo, saleOrderId: inputReq.soNumber, saleOrderItemId: inputReq.soItemNumber, operationType: OperationTypeEnum.GRADING, plantId: inputReq.plantId,jobStatus:JobCompletedEnum.NO});
           
            if(!(prodInvLogObj.length > 0)){
                

                const productionLogObj = new ProductionLog();
                productionLogObj.lotNumber = inputReq.lotNo;
                productionLogObj.subLotNumber = subLotNumber;
                productionLogObj.saleOrderId = inputReq.soNumber;
                productionLogObj.saleOrderItemId = inputReq.soItemNumber;
                productionLogObj.operationType = OperationTypeEnum.GRADING;
                // job number generation 
                const today = new Date();
                const CurrentYear = today.getFullYear();
                const CurrentMonth = today.getMonth();
                let fromDate = 0;
                let toDate = 0;
                let totalRecords = await (await this.logRepository.find({where:{operationType:OperationTypeEnum.GRADING}})).length;
                    if ((CurrentMonth+1) < 4) {
                        fromDate = (CurrentYear-1);
                        toDate = (CurrentYear);
                    } else {
                        fromDate = (CurrentYear);
                        toDate = (CurrentYear + 1);
                    }

                totalRecords = totalRecords + 1;

                let refNo = totalRecords + "";
                while (refNo.length < 4) refNo = "0" + refNo;

                const GradingJobNo = "Grading/" + (fromDate.toString().substr(-2))+"-"+(toDate.toString().substr(-2)) + "/" + refNo;

                productionLogObj.jobNumber = GradingJobNo;
                productionLogObj.plantId = gradeInvLogObj.plantId;
                productionLogObj.subPlantId = gradeInvLogObj.subPlantId;
                productionLogObj.workStationType = gradeInvLogObj.workStationType;
                productionLogObj.workstation = new WorkStations();
                productionLogObj.workstation.workstationId = gradeInvLogObj.workstation;
                productionLogObj.jobStatus = JobCompletedEnum.YES;
                productionLogObj.inputGrade = String(inputReq.count);
                productionLogObj.plannedGrade = inputReq.count;
                productionLogObj.actualGrade = String(inputReq.count);
                productionLogObj.inputQuantity = 0;
                productionLogObj.plannedOutputQuantity = inputReq.quantity;
                productionLogObj.actualOutputQuantity = inputReq.quantity;
                productionLogObj.inputBoxes = 0;
                productionLogObj.outputBoxes = inputReq.boxes;
                productionLogObj.assignedUser = inputReq.createdUser;
                productionLogObj.shift = gradeInvLogObj.shift;
                productionLogObj.createdUser = inputReq.createdUser;
                productionLogObj.prodInvId = prodInvId;
                productionLogObj.assignedTime = new Date();
                productionLogObj.reportedTime = new Date();
                productionLogObj.updatedUser = inputReq.createdUser;
                const prodLogSave = await manager.getCustomRepository(ProductionLogRepository).save(productionLogObj);
                if(!prodLogSave){
                    await manager.releaseTransaction();
                    throw new ErrorResponse(10000,'something went wrong in log update');
                }
            } else {
                console.log('yesss records')
                console.log(prodInvLogObj.length)
                // Update data in production inventory log
                // const gradeInventoryData = await this.gradeInventoryRepository.findOne()
                // let jobStatus = JobCompletedEnum.NO;
                // if(Number(prodInvLogObj.inputQuantity)===(Number(prodInvLogObj.actualOutputQuantity)+Number(inputReq.quantity))){
                    const jobStatus = JobCompletedEnum.YES;
                // }
                let prodLogUpdate
                if(prodInvLogObj.length == 1){
                console.log('lenth11')

                    prodLogUpdate = await manager.getCustomRepository(ProductionLogRepository).update({lotNumber: inputReq.lotNo, saleOrderId: inputReq.soNumber, saleOrderItemId: inputReq.soItemNumber, operationType: OperationTypeEnum.GRADING, plantId: gradeInvLogObj.plantId,subPlantId:gradeInvLogObj.subPlantId}, {subLotNumber:subLotNumber,jobStatus: jobStatus,plannedGrade:inputReq.count,actualGrade:String(inputReq.count),plannedOutputQuantity:inputReq.quantity,actualOutputQuantity:inputReq.quantity,outputBoxes: inputReq.boxes,reportedTime: new Date(),updatedUser:inputReq.createdUser});

                }else{
                console.log('morethan1')

                    const prodLogdataUpdate = await manager.getCustomRepository(ProductionLogRepository).update({lotNumber: inputReq.lotNo, saleOrderId: inputReq.soNumber, saleOrderItemId: inputReq.soItemNumber, operationType: OperationTypeEnum.GRADING, plantId: gradeInvLogObj.plantId,subPlantId:gradeInvLogObj.subPlantId}, {subLotNumber:subLotNumber,jobStatus: jobStatus,plannedGrade:inputReq.count,actualGrade:String(inputReq.count),reportedTime: new Date(),updatedUser:inputReq.createdUser});
                    if(prodLogdataUpdate.affected){
                        prodLogUpdate = await manager.getCustomRepository(ProductionLogRepository).update({productionLogId: prodInvLogObj[0].productionLogId}, {plannedOutputQuantity:inputReq.quantity,actualOutputQuantity:inputReq.quantity,outputBoxes: inputReq.boxes});
                    }else{
                        await manager.releaseTransaction();
                        throw new ErrorResponse(10000,'something went wrong in log update');
                    }
                }
                if(!(prodLogUpdate.affected)){
                    await manager.releaseTransaction();
                    throw new ErrorResponse(10000,'something went wrong in log update');
                }
        
            }
            
            // await manager.completeTransaction();
            return new CommonResponse(true,10000,'Count Assigned to SO and Reported Successfully',true);
        // } catch(error) {
        //     await manager.releaseTransaction();
        //     throw error;
        // }
        
    }

    /**
     * get grading inventory for unit id
    */
    async getGradingInventory(inputReq: UnitRequest): Promise<GradingInventoryResponse> {
        try{
        const manager = getManager();
        const grnItemColumn = GlobalVariableValues.productionVersion == 'V2' ? 'gi.plant_lot_number' : 'gi.lot_number'
        const query='select plant_type from '+appSettings.masters_db+'.unitcodes where unit_code_id='+inputReq.unitId;
        const result =await manager.query(query);
        console.log(result[0].plant_type)
        let gradeinv
        if(result[0].plant_type == UnitTypeEnum.SUB_PLANT){
            gradeinv =`select CONCAT(gi.lot_number,IF(gi.remarks IS NOT NULL,'-',''),IF(gi.remarks IS NOT NULL ,gi.remarks , '')) as concatLotNum, s.sale_order_no as soNumber,si.po_number as poNumber,s.sale_order_id as saleOrderId,sub_lot_number AS subLotNo,output_grade as count,physical_quantity as quantity,issued_quantity as issuedQty,next_operation as nextOperation,p.lot_number as lotNo,p.sale_order_id as saleOrderId from `+appSettings.production_db+`.production_inventory p left join `+appSettings.sales_db+`.sale_order s on p.sale_order_id=s.sale_order_id left join `+appSettings.sales_db+`.so_invoice_details si on p.sale_order_id=si.sale_order_id left join `+appSettings.rm_procure_db +`.grn_items gi ON ${grnItemColumn} = p.lot_number where sub_plant_id=`+inputReq.unitId+` and operation="`+OperationTypeEnum.GRADING+`" `
        }else{
            gradeinv =`select CONCAT(gi.lot_number,IF(gi.remarks IS NOT NULL,'-',''),IF(gi.remarks IS NOT NULL ,gi.remarks , '')) as concatLotNum , s.sale_order_no as soNumber,si.po_number as poNumber,s.sale_order_id as saleOrderId,sub_lot_number AS subLotNo,output_grade as count,physical_quantity as quantity,issued_quantity as issuedQty,next_operation as nextOperation,p.lot_number as lotNo,p.sale_order_id as saleOrderId from `+appSettings.production_db+`.production_inventory p left join `+appSettings.sales_db+`.sale_order s on p.sale_order_id=s.sale_order_id left join `+appSettings.sales_db+`.so_invoice_details si on p.sale_order_id=si.sale_order_id left join `+appSettings.rm_procure_db +`.grn_items gi ON ${grnItemColumn} = p.lot_number`
//   where plant_id=`+inputReq.unitId+` and sub_plant_id =0 and operation="`+OperationTypeEnum.GRADING+`" `
        if(inputReq.unitId && inputReq.unitId != 5){
            gradeinv =gradeinv+ ` where plant_id=`+inputReq.unitId+` and sub_plant_id =0 and operation="`+OperationTypeEnum.GRADING+`"`
        }
        else{
            gradeinv =gradeinv+` and sub_plant_id =0 and operation="`+OperationTypeEnum.GRADING+`"`
        }
        }
     
     const data =await manager.query(gradeinv)
     if(data){
        return new GradingInventoryResponse(true,10000,'Grading Inventory retrieved successfully',data);

     }}catch(err){
        return err;

     }

//    const gradingInv = await this.inventoryRepository.find({select:["subLotNumber","outputGrade","physicalQuantity","issuedQuantity","nextOperation","lotNumber","saleOrderId"],where:{plantId: inputReq.unitId,operation: OperationTypeEnum.GRADING}});
//         if(gradingInv.length === 0){
//             throw new ErrorResponse(10000,'Grading Inventory not found');
//         }
//         const gradingInvs:GradingInventoryModel[] = [];
//         for(const grading of gradingInv){
//             const soData = await this.saleService.getSaleOrderFewDetailsForSoId({saleOrderId: grading.saleOrderId});
//             gradingInvs.push(new GradingInventoryModel(grading.subLotNumber,grading.outputGrade,grading.physicalQuantity,grading.issuedQuantity,soData.saleOrderNumber,grading.lotNumber,grading.nextOperation,soData.poNumber,soData.saleOrderId));
//         }
     
    }

    /**
     * get grading inventory for unit id
    */
    async getGradingDashboardData(inputReq: UnitRequest): Promise<GradingDashboardResponse> {
        const manager = getManager();
        const query='select plant_type from '+appSettings.masters_db+'.unitcodes where unit_code_id='+inputReq.unitId;
        const result =await manager.query(query);
        let gradingInvdata;    
        if(result[0].plant_type==UnitTypeEnum.SUB_PLANT){        
            gradingInvdata = await this.inventoryRepository.find({select:["saleOrderItemId","outputGrade","physicalQuantity","issuedQuantity","wipQuantity"],where:{subPlantId: inputReq.unitId,operation: OperationTypeEnum.GRADING}});  
        }else{
           gradingInvdata = await this.inventoryRepository.find({select:["saleOrderItemId","outputGrade","physicalQuantity","issuedQuantity","wipQuantity"],where:{plantId: inputReq.unitId,operation: OperationTypeEnum.GRADING,subPlantId:0}});  
        }      
        const qtyToBeProcessed = await this.inventoryRepository.getQtyToBeProcessed(OperationTypeEnum.BE_HEADING, inputReq.unitId);
        let lotCount = 0;
        let qtyInProgress = 0;
        let gradingInventory = 0;
        const countMap = new Map<number,{pending:number,filled:number}>();        
        const counts = [];
        const filledQty = [];
        const pendingQty = [];
        if(gradingInvdata.length > 0){
            for(const grading of gradingInvdata){
                lotCount+=1;
                qtyInProgress+=Number(grading.wipQuantity);
                if((Number(grading.physicalQuantity) - Number(grading.issuedQuantity)) > 0){
                    gradingInventory+=Number(grading.physicalQuantity - Number(grading.issuedQuantity));
                }
                if(!countMap.has(grading.outputGrade)){
                    countMap.set(grading.outputGrade,{pending:0,filled:0});
                }
                countMap.get(grading.outputGrade).pending+=Number(grading.wipQuantity)+Number(grading.issuedQuantity);
                countMap.get(grading.outputGrade).filled+=Number(grading.physicalQuantity);
            }
            for(const[key,value] of countMap){
                console.log('@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@')
                console.log(countMap)
                counts.push(key.toString());
                filledQty.push(value.filled);
                pendingQty.push(value.pending);
            }
        }
        return new GradingDashboardResponse(true,10000,'Grading Dasboard data retrieved successfully',new GradingDashboardModel(lotCount,qtyToBeProcessed,qtyInProgress,gradingInventory,counts,pendingQty,filledQty));
    }
    async getLotNosForGrading(inputReq: UnitRequest): Promise<LotCodesResponse> {
        try{        
        const manager = getManager();
        const query='select plant_type from '+appSettings.masters_db+'.unitcodes where unit_code_id='+inputReq.unitId;
        const result =await manager.query(query);
        console.log(result[0].plant_type)
        console.log('&&&&&&&')
        let prodInv
        if(result[0].plant_type==UnitTypeEnum.SUB_PLANT){
             prodInv =`select pi.lot_number as lotNumber , CONCAT(g.lot_number,IF(g.remarks IS NOT NULL,'-',''),IF(g.remarks IS NOT NULL ,g.remarks , '')) as concatLotNum from `+appSettings.production_db+`.production_inventory pi LEFT JOIN `+appSettings.rm_procure_db +`.grn_items g ON g.lot_number = pi.lot_number where pi.sub_plant_id = `+inputReq.unitId+` and pi.operation ="`+OperationTypeEnum.GRADING+`" and pi.status in("`+FgStatusEnum.OPEN+`","`+FgStatusEnum.IN_PROGRESS+`") and pi.wip_quantity >0 `
        }else{
             prodInv =`select pi.lot_number as lotNumber ,CONCAT(g.lot_number,IF(g.remarks IS NOT NULL, ' - ' ,''),IF(g.remarks IS NOT NULL ,g.remarks , '')) as concatLotNum from `+appSettings.production_db+`.production_inventory pi LEFT JOIN `+appSettings.rm_procure_db +`.grn_items g ON g.lot_number = pi.lot_number where pi.plant_id = `+inputReq.unitId+` and pi.operation ="`+OperationTypeEnum.GRADING+`" and pi.status in("`+FgStatusEnum.OPEN+`","`+FgStatusEnum.IN_PROGRESS+`") and pi.wip_quantity >0 and pi.sub_plant_id =0 `
        }
        // const prodInv = await this.inventoryRepository.find({select:["lotNumber"],where:{plantId:inputReq.unitId,operation:OperationTypeEnum.GRADING,status: In([FgStatusEnum.OPEN,FgStatusEnum.IN_PROGRESS]),wipQuantity: MoreThan(0)}});
     const data = await manager.query(prodInv)
     if(data){
      const res = new LotCodesResponse(true, 1111, "Data retreived sucesssfuly", data)
      return res
     }
    }catch(err){
        return err
     }
    }

    async getYieldReportData(inputReq: UnitRequest):Promise<CommonResponse> {
        const manager = getManager()
        let query
        const yeildReportData:YieldReportModel[] = [];
        const plant='select plant_type from '+appSettings.masters_db+'.unitcodes where unit_code_id='+inputReq.unitId;
        const result =await manager.query(plant);
        if(result[0].plant_type == UnitTypeEnum.SUB_PLANT){
            query='select CONCAT(g.lot_number,IF(g.remarks IS NOT NULL, " - " ,""),IF(g.remarks IS NOT NULL ,g.remarks , "")) as concatLotNum, uc.unit_name as plantName,pi.lot_number as lotNumber from '+appSettings.production_db+'.production_inventory pi left join '+appSettings.masters_db+'.unitcodes uc on uc.unit_code_id=pi.sub_plant_id LEFT JOIN '+appSettings.rm_procure_db +'.grn_items g ON g.lot_number = pi.lot_number where operation="'+OperationTypeEnum.BE_HEADING+'" and pi.sub_plant_id='+inputReq.unitId+' and wip_quantity = 0 and (physical_quantity-issued_quantity) = 0'
       }else{
           query='select CONCAT(g.lot_number,IF(g.remarks IS NOT NULL, " - " ,""),IF(g.remarks IS NOT NULL ,g.remarks , "")) as concatLotNum, uc.unit_name as plantName,pi.lot_number as lotNumber from '+appSettings.production_db+'.production_inventory pi left join '+appSettings.masters_db+'.unitcodes uc on uc.unit_code_id=pi.plant_id LEFT JOIN '+appSettings.rm_procure_db +'.grn_items g ON g.lot_number = pi.lot_number where operation="'+OperationTypeEnum.BE_HEADING+'" and pi.plant_id='+inputReq.unitId+' and wip_quantity = 0 and (physical_quantity-issued_quantity) = 0 and pi.sub_plant_id=0'
       }
       const prodInvRecords = await manager.query(query)
        // const prodInvRecords = await this.inventoryRepository.createQueryBuilder('prod_log')
        // .select('lot_number')
        // .where(`operation='${OperationTypeEnum.BE_HEADING}' and plant_id=${inputReq.unitId} and wip_quantity = 0 and (physical_quantity-issued_quantity) = 0`)
        // .getRawMany();
        // if(prodInvRecords.length === 0){
        //     throw new ErrorResponse(10000,'Lot numbers not found');
        // }
        // const plantDataQry = `select unit_code_id as plantId,unit_name as plantName from `+appSettings.masters_db+`.unitcodes where unit_code_id = `+inputReq.unitId
        // const plantData = await manager.query(plantDataQry)
        
        // const plantObj = FactoriesInput.find((plant) => {
        //     return plant.id === inputReq.unitId;
        // });
        for(const record of prodInvRecords){
            const lotCodeOpsData = await this.lotCodeOpsRepository.findOne({select:["count","grnDate","indentId","quantity"],where:{
                lotNumber:record.lotNumber
            }});
            if(lotCodeOpsData){
                // get indent related data
                const indentData = await this.indentService.getIndentDetailsById({indentId:lotCodeOpsData.indentId});
                if(indentData.status){
                    const result = indentData.data;
                    const gradingResult = await this.gradeInventoryRepository.find({select:["grade","quantity","createdAt"],where:{lotNumber:record.lotNumber,plantId:inputReq.unitId}});
                    if(gradingResult.length>0){
                        let totalWeight = 0;
                        let avgCount = 0;
                        let gradingDate;
                        const countQtyModel:CountQuantityModel = {};
                        for(const grading of gradingResult){
                            countQtyModel[grading.grade] = grading.quantity;
                            gradingDate = grading.createdAt;
                            totalWeight+=Number(grading.quantity);
                            avgCount+=(Number(grading.grade)*Number(grading.quantity));
                        }
                        const yeildPercentage = (lotCodeOpsData.quantity)?Number(totalWeight)/Number(lotCodeOpsData.quantity):0;
                        const overallAvgCount = (totalWeight)?avgCount*2.2*yeildPercentage/Number(totalWeight):0;
                        yeildReportData.push(new YieldReportModel(result.supplierType,result.supplierCode,result.supplierName,result.indentDate,result.createdUser,record.plantName,record.lotNumber, result.expectedQty,result.expectedCount,lotCodeOpsData.grnDate,lotCodeOpsData.quantity,lotCodeOpsData.count,'','',gradingDate,Math.ceil(overallAvgCount),totalWeight,Math.ceil(yeildPercentage*100),[countQtyModel],record.concatLotNum));
                        console.log('----------------',yeildReportData)
                    }
                    
                }              
            }
        }
        
        return new CommonResponse(true,10000,'Data retrieved successfully',yeildReportData);
    }

    /**
     * This service will clear the wip for grading operation
     * @param inputReq 
     */
     async clearWip(inputReq: GradeLotNoRequest): Promise<CommonResponse> {          
        // get lot head on count
        const rmInvResult = await this.lotCodeOpsRepository.findOne({select:["count","saleOrderId","saleOrderItemId"],where:{plantId: inputReq.plantId,lotNumber: inputReq.lotNo}});
        if(!rmInvResult){
            throw new ErrorResponse(10000,'Lot number not found');
        }
        const prodInvRecord = await this.inventoryRepository.findOne({select:["productionInventoryId"],where:{
            lotNumber:inputReq.lotNo,saleOrderId:rmInvResult.saleOrderId,saleOrderItemId:rmInvResult.saleOrderItemId,operation:OperationTypeEnum.GRADING,plantId:inputReq.plantId
        }});
        if(!prodInvRecord){
            throw new ErrorResponse(10000,'Production inventory not found');
        }
        const updatedInvRecord = await this.inventoryRepository.update({lotNumber:inputReq.lotNo,saleOrderId:rmInvResult.saleOrderId,saleOrderItemId:rmInvResult.saleOrderItemId,operation:OperationTypeEnum.GRADING,plantId:inputReq.plantId},{wipQuantity:0});

        if(updatedInvRecord.affected===0){
            throw new ErrorResponse(10000,'Clearing WIP in production inventory failed');
        }

        return new CommonResponse(true,10000,'Lot Info Retrieved Successfully');
    }

    async deheadingInventotyData(req : UnitRequest):Promise<CommonResponse>{
        const manager = getManager();
        const query='select plant_type from '+appSettings.masters_db+'.unitcodes where unit_code_id='+req.unitId;
        const result =await manager.query(query);
        let dataQuery = `SELECT CONCAT(p.lot_number,IF(g.remarks IS NOT NULL,"-",""),IF(g.remarks IS NOT NULL ,g.remarks , "")) as concatLotNum, p.lot_number AS lotNumber , p.next_operation AS operation,p.issued_quantity AS qty,so.po_number AS soNumber,sc.variant_code AS variantCode FROM `+appSettings.production_db + `.production_inventory p 
        LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details so ON so.sale_order_id = p.sale_order_id
        LEFT JOIN ` + appSettings.sales_db + `.sale_order_items s ON s.sale_order_item_id = p.sale_order_item_id 
        LEFT JOIN ` + appSettings.masters_db + `.sku_codes sc ON sc.sku_code_id = s.varient_id 
        LEFT JOIN `+appSettings.rm_procure_db +`.grn_items g ON g.lot_number = p.lot_number
        WHERE p.next_operation = 'GRADING' AND status!="${FgStatusEnum.CLOSE}" `
        if(result[0].plant_type==UnitTypeEnum.SUB_PLANT){
            dataQuery += "AND p.sub_plant_id="+req.unitId;
          }else{
            if(req.unitId && req.unitId!=5){
                dataQuery += "AND p.plant_id="+req.unitId+' and p.sub_plant_id = 0';
            }
            else{
                dataQuery += ' and p.sub_plant_id = 0';
            }
            
          }
          const data =await manager.query(dataQuery);
          if(data.length > 0 ){
            return new CommonResponse(true,10000,'Data Retrieved Successfully',data);
          }else{
            throw new ErrorResponse(10000,'No data found');
          }
    }


    async createGradeReporting(req : GradeReportingDto):Promise<CommonResponse>{
        const connection = getConnection();
        const transactionManager: QueryRunner = connection.createQueryRunner();
        // const manager = getManager()
        try{
            await transactionManager.startTransaction()
            const result =await this.unitCodesService.getPlantDetailsById(new PlantIdRequest(req.plantId))
            let issuedQty = 0
            const saveFlag = new Set<boolean>()

            const getMailLotAgainstLot = `SELECT main_batch_num as mainLot FROM ${appSettings.rm_procure_db} .grn_items WHERE plant_lot_number = '${req.lotNo}' and year = ${req.year}`
            const getMainLot = await transactionManager.query(getMailLotAgainstLot)

            const getInputCountQry = `SELECT input_grade FROM ${appSettings.production_db} .production_inventory WHERE operation = '${req.previousOperation}' AND lot_number = '${req.lotNo}' and year = ${req.year} `
            const inputCount = await transactionManager.query(getInputCountQry)

            const getHonQtyQuery = `select IF(reweighment_quantity > 0 , reweighment_quantity,quantity) AS quantity,IF(reweighment_count > 0 , reweighment_count,count) as count,price from ${appSettings.rm_procure_db} .grn_items where plant_lot_number = '${req.lotNo}' and year = ${req.year}`
            const getHonQty = await transactionManager.query(getHonQtyQuery)

            // const getGrnItemCountAgainstMainLotQry = `select count(*) as grnItemCount from ${appSettings.rm_procure_db} .grn_items where main_batch_num = '${getMainLot[0].mainLot}'`
            // const getGrnItemCountAgainstMainLotQry = `select count(*) as grnItemCount from ${appSettings.production_db} .lot_code_data where main_lot_after_club = '${getMainLot[0].mainLot}' group by lot_club_status,IF(lot_club_status =1 ,main_lot_after_club,lot_number)`
            // const grnItemCountAgainstMainLot = await transactionManager.query(getGrnItemCountAgainstMainLotQry)
            // const grnItemCount = grnItemCountAgainstMainLot.length > 0 ? grnItemCountAgainstMainLot[0].grnItemCount : 0
            // const grnItemCount = grnItemCountAgainstMainLot.length > 0 ? grnItemCountAgainstMainLot.length : 0

            // const getGradingCountAgainstMainLot = `SELECT COUNT(DISTINCT(lot_number)) as gradeCount FROM ${appSettings.production_db} .grade_inventory WHERE main_lot = '${getMainLot[0].mainLot}'  GROUP BY main_lot`
            // const gradeCoutnAgainstMainLot = await transactionManager.query(getGradingCountAgainstMainLot)
            // const gradeCount = gradeCoutnAgainstMainLot.length > 0 ? gradeCoutnAgainstMainLot[0].gradeCount : 0
              const getHarvestTypeQuery = `SELECT harvest_type,indent_date as indentDate FROM ${appSettings.rm_procure_db} .indent i LEFT JOIN ${appSettings.rm_procure_db} .grn_items gi ON gi.indent_id = i.indent_id WHERE gi.plant_lot_number = '${req.lotNo}' and year = ${req.year}`
            const getHarvestType = await transactionManager.manager.query(getHarvestTypeQuery)
            

            // const gettotalHONQtyQry = `SELECT IF(reweighment_quantity > 0 , SUM(reweighment_quantity),SUM(quantity)) AS quantity FROM ${appSettings.rm_procure_db} .grn_items WHERE plant_lot_number = '${req.lotNo}'`
             const gettotalHONQtyQry = `SELECT SUM(quantity) AS quantity FROM ${appSettings.production_db} .lot_code_data WHERE IF(lot_club_status = 1, clubbed_main_lot IN ('${req.lotNo}') , lot_number IN ('${req.lotNo}')) AND year = ${req.year}`
            const getTotHONQty = await transactionManager.manager.query(gettotalHONQtyQry)

            const getTotalGradedQtyQuery = `SELECT SUM(quantity) AS qty FROM ${appSettings.production_db} .grade_inventory WHERE lot_number = '${req.lotNo}' and year = ${req.year}`
            const getTotalGradedQty = await transactionManager.manager.query(getTotalGradedQtyQuery)

            console.log(getHonQty,'getHonQty',getTotalGradedQty,'getTotalQty')

            const totalGradedQty = getTotalGradedQty[0].qty ? getTotalGradedQty[0].qty : 0
            const yieldPer = ((Number(totalGradedQty)+ Number(req.totalGradedQty)) / Number(getTotHONQty[0].quantity)) * 100
            
            console.log(yieldPer,'==================yieldper')
            const getRmRateQuery = `select count,price from ${appSettings.rm_procure_db} .rm_rates where category = '${CompanyCategoryEnum.OWN}' and type = '${getHarvestType[0].harvest_type}'`
            const getRmRate = await transactionManager.manager.query(getRmRateQuery)
            // const rmRateReq = new RmRatesInfoReq(undefined,getHarvestType[0].harvest_type,CompanyCategoryEnum.OWN,undefined,getHarvestType[0].indentDate)
            // const getRmrates = await this.rmCountPriceListService.getRmRatesAgainstUploadedDate(rmRateReq)
            const rmRatesMap = new Map<number,any>()
            for(const rec of getRmRate){
                if(!rmRatesMap.has(rec.count)){
                    rmRatesMap.set(Number(rec.count),{count:Number(rec.count),price:rec.price})
                }
            }

            // const getHalfCountsInfo = await this.rmCountPriceListService.getHalfCountRangesInfo()
            // const halfCountMap = new Map<any,any>()
            // for(const rec of getHalfCountsInfo.data){
            //     if(!halfCountMap.has(JSON.stringify({minCount:rec.min_count,maxCount:rec.maxCount}))){
            //         halfCountMap.set(JSON.stringify({minCount:rec.min_count,maxCount:rec.maxCount}),rec)
            //     }
            // }

            const updateSampleYield = await transactionManager.manager.getRepository(LotCodeOpsEntity).update({lotNumber:req.lotNo,year:req.year},{sampleYield:req.sampleYield})
            if(updateSampleYield.affected){
                saveFlag.add(true)
            }else{
                saveFlag.add(false)
                await transactionManager.rollbackTransaction()
                await transactionManager.release()
                return new CommonResponse(false,0,'Somethign went wrong in updating sample yield') 
            }
            let totalQty = 0
            for(const rec of req.grades){

                if(rec.quantity > 0){
                    totalQty += Number(rec.quantity)
                    const gradeRangeQry = `SELECT grade_range FROM ${appSettings.masters_db} .grade_ranges WHERE min_count <= ${rec.grade} AND max_count >= ${rec.grade}`
                    const gradeRange = await transactionManager.query(gradeRangeQry)
                    // Production Inventory Saving
                    const findPrevRec = await transactionManager.manager.find(ProductionInventory,{where:{lotNumber:req.lotNo,inputGrade:inputCount[0].input_grade,outputGrade:rec.grade,operation:OperationTypeEnum.GRADING,prevOperation:req.previousOperation,year:req.year}})
                    const prodInvObj = new ProductionInventory()
                    if(findPrevRec.length > 0){
                        prodInvObj.productionInventoryId = findPrevRec[0].productionInventoryId
                        prodInvObj.physicalQuantity = Number(rec.quantity) + Number(findPrevRec[0].physicalQuantity)
                        prodInvObj.opBoxes = Number(rec.boxes) + Number(findPrevRec[0].opBoxes)
                        prodInvObj.updatedUser = req.createdUser
                    }else{
                        prodInvObj.physicalQuantity = rec.quantity
                        prodInvObj.opBoxes = rec.boxes
                        prodInvObj.createdUser = req.createdUser
                    }
                    prodInvObj.operation = OperationTypeEnum.GRADING
                    prodInvObj.prevOperation = req.previousOperation
                    prodInvObj.inputGrade = inputCount[0].input_grade
                    prodInvObj.outputGrade = String(rec.grade)
                    prodInvObj.lotNumber = req.lotNo
                    prodInvObj.subLotNumber = req.lotNo
                    prodInvObj.plantId = req.plantId
                    prodInvObj.year = req.year
                    issuedQty += rec.quantity
                    const prodInvSave = await transactionManager.manager.save(ProductionInventory,prodInvObj)
                    if(!prodInvSave){
                        saveFlag.add(false)
                        await transactionManager.rollbackTransaction()
                        await transactionManager.release()
                        return new CommonResponse(false,0,'Somethign went wrong in saving in production inventory')
                    }
    
    
                    // Production Log Saving
                    // job number generation 
                    let today = new Date();
                    let CurrentYear = today.getFullYear();
                    let CurrentMonth = today.getMonth();
                    let fromDate = 0;
                    let toDate = 0;
                    let totalRecords = await (await this.logRepository.find({ where: { operationType: OperationTypeEnum.GRADING } })).length;
    
                    if (CurrentMonth < 4) {
                        fromDate = (CurrentYear-1);
                        toDate = (CurrentYear);
                    } else {
                        fromDate = (CurrentYear);
                        toDate = (CurrentYear + 1);
                    }
    
                    totalRecords = totalRecords + 1;
    
                    var refNo = totalRecords + "";
                    while (refNo.length < 4) refNo = "0" + refNo;
    
                    const grnJobNo = "GRADING/" + (fromDate.toString().substr(-2)) + "-" + (toDate.toString().substr(-2)) + "/" + refNo;
    
                    const prodLogObj = new ProductionLog()
                    prodLogObj.lotNumber = req.lotNo
                    prodLogObj.subLotNumber = req.lotNo
                    prodLogObj.operationType = OperationTypeEnum.GRADING
                    prodLogObj.jobNumber = grnJobNo
                    prodLogObj.plantId = req.plantId
                    prodLogObj.jobStatus = JobCompletedEnum.YES
                    prodLogObj.assignCooking = false
                    prodLogObj.inputGrade = inputCount[0].input_grade
                    prodLogObj.actualOutputQuantity = rec.quantity
                    prodLogObj.prodInvId = prodInvSave.productionInventoryId
                    prodLogObj.workStation = req.workstation
                    prodLogObj.shift = ShiftsEnum[req.shift]
                    prodLogObj.createdUser = req.createdUser
                    prodLogObj.assignedUser = req.createdUser
                    prodLogObj.prevOperation = req.previousOperation
                    prodLogObj.outputBoxes = rec.boxes
                    prodLogObj.date = req.date
                    prodLogObj.materialFrom = req.materialFrom
                    prodLogObj.actualGrade = String(rec.grade)
                    prodLogObj.year = req.year
                    const prodLogSave = await transactionManager.manager.save(ProductionLog,prodLogObj)
                    if(!prodLogSave){
                        saveFlag.add(false)
                        await transactionManager.rollbackTransaction()
                        await transactionManager.release()
                        return new CommonResponse(false,0,'Something went wrong in saving in production log')
                    }
    
                    //Grade Inventory Log Saving
                    const gradeInvLog = new GradeInventoryLog();
                      //plant and subplant wise data saving
                      if(result.data.plantType == UnitTypeEnum.PLANT){
                        gradeInvLog.subPlantId = 0;
                        gradeInvLog.plantId = req.plantId;
                    }
                    if(result.data.plantType == UnitTypeEnum.SUB_PLANT){
                        gradeInvLog.subPlantId = req.plantId;
                        gradeInvLog.plantId = req.mainPlantId;
    
                    }
                    // gradeInvLog.plantId = req.plantId;
                    gradeInvLog.shift = ShiftsEnum[req.shift];
                    gradeInvLog.workStationType = req.workstationType;
                    gradeInvLog.workstation = req.workstation;
                    gradeInvLog.lotNumber = req.lotNo;
                    gradeInvLog.grade = rec.grade;
                    gradeInvLog.boxes = rec.boxes;
                    gradeInvLog.createdUser = req.createdUser;
                    gradeInvLog.quantity = rec.quantity;
                    gradeInvLog.quantityType = GradeInvStatusEnum.REPORTED;
                    gradeInvLog.supervisor = req.supervisor
                    gradeInvLog.materialFrom = req.materialFrom
                    gradeInvLog.year = req.year
                    gradeInvLog.date = req.date
                    const gradeInvLogSave = await transactionManager.manager.save(GradeInventoryLog,gradeInvLog)
    
                    if(!gradeInvLogSave){
                        saveFlag.add(false)
                        await transactionManager.rollbackTransaction()
                        await transactionManager.release()
                        return new CommonResponse(false,0,'Something went wrong in saving in Grade Inventory Log')
                    }
    
    
                    //Grade Inventory Saving
                    const gradeInv = await transactionManager.manager.findOne(GradeInventory,{lotNumber:req.lotNo,grade:rec.grade,year:req.year});
    
                    console.log(gradeInv)
    
                    const gradeInvObj = new GradeInventory();
                    const calhonCount = Number((Number(1000/((454/Number(rec.grade)/(yieldPer))*100))).toFixed(1))
                    const getrefeCountQry = `SELECT reference_count as count FROM ${appSettings.rm_procure_db} .half_count_ranges WHERE min_count <= ${Number(calhonCount)} AND max_count >= ${Number(calhonCount)}`
                    const referenceCount = await transactionManager.manager.query(getrefeCountQry)
                    if(referenceCount.length == 0){
                        await transactionManager.rollbackTransaction()
                        await transactionManager.release()
                        return new CommonResponse(false,0,`Reference count not found for the HON Count ${Number(calhonCount)}`)
                    }
                    gradeInvObj.priceCount = referenceCount[0].count
                    gradeInvObj.honCount = calhonCount
                    let rmRate
                    const rmRateReq = new RmRatesInfoReq(undefined,getHarvestType[0].harvest_type,CompanyCategoryEnum.OWN,Number(calhonCount),getHarvestType[0].indentDate)
                    const getRmrates = await this.rmCountPriceListService.getRmRatesAgainstUploadedDate(rmRateReq)
                    console.log(getRmrates)
                    if(!(getRmrates.status)){
                        await transactionManager.rollbackTransaction()
                        await transactionManager.release()
                        return new CommonResponse(false,0,`RM rate not found for HON count ${referenceCount[0].count}`)
                    }
                    rmRate = getRmrates.data[0].price
                        //commented on 07/04...price need to fetch from rm rates against date
                    // if(rmRatesMap.get(Number(calhonCount)) == undefined){
                        // let decimalIndex = calhonCount.toString().indexOf(".");
                        // let afterDecimalValue = calhonCount.toString().substring(decimalIndex+1);
                        // let beforeDecimalValue = calhonCount.toString().substring(0,decimalIndex);
                        // const upperCountObj = rmRatesMap.get(Number(beforeDecimalValue))
                        // const lowerCountObj = rmRatesMap.get(Number(beforeDecimalValue)+1)
                        // if(calhonCount <= 40){
                        //     if(Number(afterDecimalValue) <= 3){
                        //         if(upperCountObj == undefined){
                        //             await transactionManager.rollbackTransaction()
                        //             await transactionManager.release()
                        //             return new CommonResponse(false,0,`RM rate not found for HON count ${calhonCount}`)
                        //         }else{
                        //             rmRate = upperCountObj.price
                        //           }
                        //     }else if(Number(afterDecimalValue) == 4 || Number(afterDecimalValue) == 5 || Number(afterDecimalValue) ==6){
                            
                        //         if(lowerCountObj != undefined && upperCountObj != undefined){
                        //           const diff = Number(upperCountObj.price) - Number(lowerCountObj.price)
                        //           const halfdiff = Number(diff)/2
                        //           rmRate = Number(upperCountObj.price) + Math.abs(Number(halfdiff))
                        //         }else{
                        //             await transactionManager.rollbackTransaction()
                        //             await transactionManager.release()
                        //             return new CommonResponse(false,0,`RM rate not found for HON count ${calhonCount}`)
                        //         }
                        //     }else{
                        //         if(lowerCountObj == undefined){
                        //           await transactionManager.rollbackTransaction()
                        //           await transactionManager.release()
                        //               return new CommonResponse(false,0,`RM rate not found for HON count ${calhonCount}`)
                        //         }else{
                        //           rmRate = lowerCountObj.price
                        //         }
                        //       }
    
                        // }else{
                        //     if(Number(afterDecimalValue) <= 3){
                        //       if(upperCountObj == undefined){
                        //         await transactionManager.rollbackTransaction()
                        //         await transactionManager.release()
                        //             return new CommonResponse(false,0,`RM rate not found for HON count ${calhonCount}`)
                        //       }else{
                        //         rmRate = upperCountObj.price
                        //       }
                        //     }else if(Number(afterDecimalValue) == 4 || Number(afterDecimalValue) == 5){
                        //       if(lowerCountObj != undefined && upperCountObj != undefined){
                        //         const diff = Number(upperCountObj.price) - Number(lowerCountObj.price)
                        //         const halfdiff = Number(diff)/2
                        //         rmRate = Number(upperCountObj.price) + Math.abs(Number(halfdiff))
                        //       }else{
                        //         await transactionManager.rollbackTransaction()
                        //         await transactionManager.release()
                        //             return new CommonResponse(false,0,`RM rate not found for HON count ${calhonCount}`)
                        //       }
                        //     }else{
                        //       if(lowerCountObj == undefined){
                        //         await transactionManager.rollbackTransaction()
                        //         await transactionManager.release()
                        //             return new CommonResponse(false,0,`RM rate not found for HON count ${calhonCount}`)
                        //       }else{
                        //         rmRate = lowerCountObj.price
                        //       }
                        //     }
                        // }
                        //commented on 07/04...price need to fetch from rm rates against date
                    //     console.log(referenceCount,'refercnecount')
                    //     if(rmRatesMap.get(Number(referenceCount[0].count))  == undefined){
                    //         await transactionManager.rollbackTransaction()
                    //         await transactionManager.release()
                    //         return new CommonResponse(false,0,`RM rate not found for HON count ${referenceCount[0].count}`)
                    //     }else{
                    //         rmRate = rmRatesMap.get(Number(referenceCount[0].count)).price
                    //     }
                    // }else{
                    //     rmRate = rmRatesMap.get(Number(calhonCount)).price
                    // }
    
                    if(gradeInv) {
                        gradeInvObj.gradeInvId = gradeInv.gradeInvId
                        gradeInvObj.boxes = Number(rec.boxes )+ Number(gradeInv.boxes);
                        gradeInvObj.quantity = Number(gradeInv.quantity)+Number(rec.quantity);
                        gradeInvObj.updatedUser = req.createdUser; 
                        gradeInvObj.honQuantity = ((Number(gradeInv.quantity)+Number(rec.quantity)) / (yieldPer))* 100
                        gradeInvObj.rmRate = rmRate
                        gradeInvObj.amount = Number(((Number(gradeInv.quantity)+Number(rec.quantity)) / (yieldPer))* 100) * Number(rmRate)
                    } else {
                        //plnat and subplant wise data saving
                        if(result.data.plantType == UnitTypeEnum.PLANT){
                            gradeInvObj.subPlantId = 0;
                            gradeInvObj.plantId = req.plantId;
                        }
                        if(result.data.plantType == UnitTypeEnum.SUB_PLANT){
                            gradeInvObj.subPlantId = req.plantId;
                            gradeInvObj.plantId = req.mainPlantId;
        
                        }
                        gradeInvObj.lotNumber = req.lotNo;
                        gradeInvObj.grade = rec.grade;
                        gradeInvObj.boxes = rec.boxes;
                        gradeInvObj.quantity = rec.quantity;
                        gradeInvObj.createdUser = req.createdUser; 
                        gradeInvObj.grnHonCount = getHonQty[0].count
                        gradeInvObj.grnHonQuantity = getTotHONQty[0].quantity
                        gradeInvObj.grnRmRate = getHonQty[0].price
                        gradeInvObj.honQuantity = ((Number(rec.quantity)) / (yieldPer))* 100
                        gradeInvObj.rmRate = rmRate
                        gradeInvObj.amount = Number(((Number(rec.quantity)) / (yieldPer))* 100) * Number(rmRate)
                        gradeInvObj.supervisor = req.supervisor
                        gradeInvObj.gradeRange = gradeRange.length > 0 ? gradeRange[0].grade_range : null
                        gradeInvObj.materialFrom = req.materialFrom
                        gradeInvObj.mainLot = getMainLot[0].mainLot
                        gradeInvObj.year = req.year

                    }
                    
                 
                    const gradeInvSave = await transactionManager.manager.save(GradeInventory,gradeInvObj)
                    if(!gradeInvSave){
                        saveFlag.add(false)
                        await transactionManager.rollbackTransaction()
                        await transactionManager.release()
                        return new CommonResponse(false,0,'Something went wrong in saving in grade inventory')
                    }
                }
        }
        if(!(saveFlag.has(false))){
            // const honInfoUpdateFlag = new Set<boolean>()
            const updateIssuedQty = await transactionManager.manager.update(ProductionInventory,{lotNumber:req.lotNo,operation:req.previousOperation,inputGrade:inputCount[0].input_grade,year:req.year},{issuedQuantity:() => `issued_quantity + ${issuedQty}`})
            if(updateIssuedQty.affected){
                // console.log(grnItemCount,'grnitemcounr',gradeCount,'gradecount')
                // if(Number(grnItemCount) == Number(gradeCount) + 1){
                //     const calHonInfoUpdate = await this.updateHonInfoInGradeInv(getMainLot[0].mainLot,req.year,transactionManager)
                //     if(calHonInfoUpdate.status){
                //         honInfoUpdateFlag.add(true)
                //         // await transactionManager.commitTransaction()
                //         // return new CommonResponse(true,0,'Grading Reported successfully')
                //     }else{
                //         honInfoUpdateFlag.add(false)
                //         await transactionManager.rollbackTransaction()
                // await transactionManager.release()
                //         return new CommonResponse(false,0,calHonInfoUpdate.internalMessage)
                //     }
                // }
                // if(!(honInfoUpdateFlag.has(false))){
                //     await transactionManager.commitTransaction()
                //     return new CommonResponse(true,0,'Grading Reported successfully')
                // }else{
                //     await transactionManager.rollbackTransaction()
                    // await transactionManager.release()
                //     return new CommonResponse(false,0,'Something went wrong in updating cal Hon info')
                // }
                await transactionManager.commitTransaction()
                await transactionManager.release()

                return new CommonResponse(true,0,'Grading Reported successfully')
            }else{
                await transactionManager.rollbackTransaction()
                await transactionManager.release()
                return new CommonResponse(false,0,'Something went wrong in updating issued qty')
            }
        }else{
            await transactionManager.rollbackTransaction()
            await transactionManager.release()
            return new CommonResponse(false,0,'Something went wrong')
        }

        }catch(err){
            console.log(err,'err')
            await transactionManager.rollbackTransaction()
            await transactionManager.release()
            return new CommonResponse(false,0,'Something went wrong',err)
        }
    }


    async getGradingAnalysisReport(req?: ProductionLogRequest): Promise<CommonResponse> {
        try {
            const manager = getManager();
//             let gradeQuery = `
//            SELECT 
//     lcd.scode,
//     lcd.honQuantity,
//     lcd.count,
//     DATE(pl.date) AS date,
//     gi.grade_range AS grade,
//     SUM(gi.quantity) AS quantity
// FROM (
  
//     SELECT 
//         CASE 
//             WHEN lcd.lot_club_status = 1 THEN lcd.clubbed_main_lot
//             ELSE lcd.lot_number
//         END AS scode,
//         CASE 
//             WHEN lcd.lot_club_status = 1 THEN (
//                 SELECT SUM(inner_lcd.quantity) 
//                 FROM ${appSettings.production_db}.lot_code_data inner_lcd
//                 WHERE inner_lcd.clubbed_main_lot = lcd.clubbed_main_lot
//             )
//             ELSE lcd.quantity
//         END AS honQuantity,
//         lcd.count,
//         lcd.lot_number
//     FROM 
//        ${appSettings.production_db}.lot_code_data lcd
// ) AS lcd
// LEFT JOIN (
   
//     SELECT lot_number, grade_range, SUM(quantity) AS quantity 
//     FROM ${appSettings.production_db}.grade_inventory 
//     GROUP BY lot_number, grade_range
// ) gi 
// ON gi.lot_number = lcd.lot_number
// LEFT JOIN (
   
//     SELECT DISTINCT lot_number, input_grade, date 
//     FROM ${appSettings.production_db}.production_log 
//     WHERE operation = 'GRADING'
// ) pl 
// ON pl.lot_number = gi.lot_number 
// AND lcd.count = pl.input_grade
//         `;
        
//         // Add date filter if provided
//         if (req.fromDate && req.toDate) {
//             gradeQuery += `
//                 AND DATE(pl.date) BETWEEN '${req.fromDate}' AND '${req.toDate}'`;
//         }
        
//         // Append GROUP BY clause
//         gradeQuery += `
//            GROUP BY 
//   lcd.scode, 
//     lcd.honQuantity, 
//     lcd.count, 
//     DATE(pl.date), 
//     gi.grade_range `;

    let gradeQuery = `select g.lot_number as scode,g.grn_hon_count as count,sum(g.quantity) as quantity ,g.grn_hon_quantity as honQuantity,DATE(gl.date) as date,g.grade_range as grade
        from ${appSettings.production_db} .grade_inventory g 
        left join ${appSettings.production_db} .grade_inventory_log gl on gl.lot_number = g.lot_number and gl.grade = g.grade
        where g.grade_inv_id > 0 
         `
        if (req.fromDate && req.toDate) {
            gradeQuery += `
                AND DATE(gl.date) BETWEEN '${req.fromDate}' AND '${req.toDate}'`;
        }
        gradeQuery += ` group by g.lot_number,g.grade_range,gl.date`
        
        // Execute the query
        const gradeResult = await manager.query(gradeQuery);
        
    
            // Format the date in the response
            const formattedResult = gradeResult.map((record: any) => ({
                ...record,
                date: record.date ? moment(record.date).format('YYYY-MM-DD') : null // Format date to "YYYY-MM-DD"
            }));
    
            if (formattedResult.length > 0) {
                return new CommonResponse(true, 1, 'Data retrieved successfully', formattedResult);
            } else {
                return new CommonResponse(false, 0, 'No data found', []);
            }
        } catch (err) {
            throw err;
        }
    }
    



//     async getGradingSummaryReport(): Promise<CommonResponse>{
//         try{
//             const manager =getManager();
//             let gradeSumQuery =` SELECT
//     CASE 
//         WHEN lcd.count BETWEEN 0 AND 20 THEN 'upto20'
//         WHEN lcd.count BETWEEN 21 AND 30 THEN '21-30'
//         WHEN lcd.count BETWEEN 31 AND 40 THEN '31-40'
//         WHEN lcd.count BETWEEN 41 AND 50 THEN '41-50'
//         WHEN lcd.count BETWEEN 51 AND 60 THEN '51-60'
//         WHEN lcd.count BETWEEN 61 AND 70 THEN '61-70'
//         WHEN lcd.count BETWEEN 71 AND 80 THEN '71-80'
//         WHEN lcd.count BETWEEN 81 AND 90 THEN '81-90'
//         WHEN lcd.count BETWEEN 91 AND 100 THEN '91-100'
//     END AS honCount,
//     SUM(lcd.quantity) AS honQuantity,
//     SUM(CASE WHEN gi.grade_range = '8/12' THEN lcd.quantity ELSE 0 END) AS '8/12',
//     SUM(CASE WHEN gi.grade_range = '13/15' THEN lcd.quantity ELSE 0 END) AS '13/15',
//     SUM(CASE WHEN gi.grade_range = '16/20' THEN lcd.quantity ELSE 0 END) AS '16/20',
//     SUM(CASE WHEN gi.grade_range = '21/25' THEN lcd.quantity ELSE 0 END) AS '21/25',
//     SUM(CASE WHEN gi.grade_range = '26/30' THEN lcd.quantity ELSE 0 END) AS '26/30',
//     SUM(CASE WHEN gi.grade_range = '31/35' THEN lcd.quantity ELSE 0 END) AS '31/35',
//     SUM(CASE WHEN gi.grade_range = '31/40' THEN lcd.quantity ELSE 0 END) AS '31/40',
//     SUM(CASE WHEN gi.grade_range = '41/50' THEN lcd.quantity ELSE 0 END) AS '41/50',
//     SUM(CASE WHEN gi.grade_range = '51/60' THEN lcd.quantity ELSE 0 END) AS '51/60',
//     SUM(CASE WHEN gi.grade_range = '61/70' THEN lcd.quantity ELSE 0 END) AS '61/70',
//     SUM(CASE WHEN gi.grade_range = '71/90' THEN lcd.quantity ELSE 0 END) AS '71/90',
//     SUM(CASE WHEN gi.grade_range = '90/110' THEN lcd.quantity ELSE 0 END) AS '90/110',
//     SUM(CASE WHEN gi.grade_range = '100/120' THEN lcd.quantity ELSE 0 END) AS '100/120',
//     SUM(lcd.quantity) AS TOTAL,
//     lcd.lot_number
// FROM
//      ${appSettings.production_db}.lot_code_data lcd
// LEFT JOIN
//     ${appSettings.production_db}.grade_inventory gi ON gi.lot_number = lcd.lot_number
// WHERE
//     lcd.count BETWEEN 0 AND 100 
// GROUP BY
//     CASE 
//         WHEN lcd.count BETWEEN 0 AND 20 THEN 'upto20'
//         WHEN lcd.count BETWEEN 21 AND 30 THEN '21-30'
//         WHEN lcd.count BETWEEN 31 AND 40 THEN '31-40'
//         WHEN lcd.count BETWEEN 41 AND 50 THEN '41-50'
//         WHEN lcd.count BETWEEN 51 AND 60 THEN '51-60'
//         WHEN lcd.count BETWEEN 61 AND 70 THEN '61-70'
//         WHEN lcd.count BETWEEN 71 AND 80 THEN '71-80'
//         WHEN lcd.count BETWEEN 81 AND 90 THEN '81-90'
//         WHEN lcd.count BETWEEN 91 AND 100 THEN '91-100'
// END
// ORDER BY
//     CASE 
//         WHEN lcd.count BETWEEN 0 AND 20 THEN 1
//         WHEN lcd.count BETWEEN 21 AND 30 THEN 2
//         WHEN lcd.count BETWEEN 31 AND 40 THEN 3
//         WHEN lcd.count BETWEEN 41 AND 50 THEN 4
//         WHEN lcd.count BETWEEN 51 AND 60 THEN 5
//         WHEN lcd.count BETWEEN 61 AND 70 THEN 6
//         WHEN lcd.count BETWEEN 71 AND 80 THEN 7
//         WHEN lcd.count BETWEEN 81 AND 90 THEN 8
//         WHEN lcd.count BETWEEN 91 AND 100 THEN 9
// END;`
  
//             const gradeSumResult = await manager.query(gradeSumQuery)
//             if(gradeSumResult.length>0){
//                 return new CommonResponse(true,1,'Data retrieved sucessfully',gradeSumResult)
//              }else{
//                 return new CommonResponse(false, 0,'No data found',[])
            
//              }
//                     }catch(err){
//                         throw(err)
//                       }

//         }

async getGradingSummaryReport(req: BillNumberRequest): Promise<CommonResponse> {
    try {
      const manager = getManager();
      let gradeSumQuery = `
        SELECT SUM(gi.quantity),
        SUM(grn_hon_quantity) as honQuantity,
          CASE
            WHEN gi.grn_hon_count BETWEEN 0 AND 20.1 THEN 'upto20'
            WHEN gi.grn_hon_count BETWEEN 20.2 AND 30.1 THEN '21-30'
            WHEN gi.grn_hon_count BETWEEN 30.2 AND 40.1 THEN '31-40'
            WHEN gi.grn_hon_count BETWEEN 40.2 AND 50.1 THEN '41-50'
            WHEN gi.grn_hon_count BETWEEN 50.2 AND 60.1 THEN '51-60'
            WHEN gi.grn_hon_count BETWEEN 60.2 AND 70.1 THEN '61-70'
            WHEN gi.grn_hon_count BETWEEN 70.2 AND 80.1 THEN '71-80'
            WHEN gi.grn_hon_count BETWEEN 80.2 AND 90.1 THEN '81-90'
            WHEN gi.grn_hon_count BETWEEN 90.2 AND 100.1 THEN '91-100'
            WHEN gi.grn_hon_count BETWEEN 100.2 AND 200 THEN '101-200'
          END AS honCount,
          SUM(CASE WHEN gi.grade_range = '8/12' THEN gi.quantity ELSE 0 END) AS '8/12',
          SUM(CASE WHEN gi.grade_range = '13/15' THEN gi.quantity ELSE 0 END) AS '13/15',
          SUM(CASE WHEN gi.grade_range = '16/20' THEN gi.quantity ELSE 0 END) AS '16/20',
          SUM(CASE WHEN gi.grade_range = '21/25' THEN gi.quantity ELSE 0 END) AS '21/25',
          SUM(CASE WHEN gi.grade_range = '26/30' THEN gi.quantity ELSE 0 END) AS '26/30',
          SUM(CASE WHEN gi.grade_range = '31/35' THEN gi.quantity ELSE 0 END) AS '31/35',
          SUM(CASE WHEN gi.grade_range = '36/40' THEN gi.quantity ELSE 0 END) AS '36/40',
          SUM(CASE WHEN gi.grade_range = '41/50' THEN gi.quantity ELSE 0 END) AS '41/50',
          SUM(CASE WHEN gi.grade_range = '51/60' THEN gi.quantity ELSE 0 END) AS '51/60',
          SUM(CASE WHEN gi.grade_range = '61/70' THEN gi.quantity ELSE 0 END) AS '61/70',
          SUM(CASE WHEN gi.grade_range = '71/90' THEN gi.quantity ELSE 0 END) AS '71/90',
          SUM(CASE WHEN gi.grade_range = '91/110' THEN gi.quantity ELSE 0 END) AS '90/110',
          SUM(CASE WHEN gi.grade_range = '110/200' THEN gi.quantity ELSE 0 END) AS '100/120',
          grade_range
        FROM
          ${appSettings.production_db} .grade_inventory gi
        LEFT JOIN
          ${appSettings.production_db} .grade_inventory_log gl ON gl.lot_number = gi.lot_number AND gl.grade = gi.grade
        WHERE
          1 = 1`;
      
      // Apply date filter if fromDate and toDate are provided
      if (req.fromDate && req.toDate) {
        gradeSumQuery += `
          AND DATE(gl.date) BETWEEN '${req.fromDate}' AND '${req.toDate}'`;
    }
    
  
      gradeSumQuery += `
      GROUP BY 
          CASE
            WHEN grn_hon_count BETWEEN 0 AND 20.1 THEN 'upto20'
            WHEN grn_hon_count BETWEEN 20.2 AND 30.1 THEN '21-30'
            WHEN grn_hon_count BETWEEN 30.2 AND 40.1 THEN '31-40'
            WHEN grn_hon_count BETWEEN 40.2 AND 50.1 THEN '41-50'
            WHEN grn_hon_count BETWEEN 50.2 AND 60.1 THEN '51-60'
            WHEN grn_hon_count BETWEEN 60.2 AND 70.1 THEN '61-70'
            WHEN grn_hon_count BETWEEN 70.2 AND 80.1 THEN '71-80'
            WHEN grn_hon_count BETWEEN 80.2 AND 90.1 THEN '81-90'
            WHEN grn_hon_count BETWEEN 90.2 AND 100.1 THEN '91-100'
            WHEN gi.grn_hon_count BETWEEN 100.2 AND 200 THEN '101-200'
          END
      ORDER BY
          CASE
            WHEN grn_hon_count BETWEEN 0 AND 20.1 THEN 1
            WHEN grn_hon_count BETWEEN 20.2 AND 30.1 THEN 2
            WHEN grn_hon_count BETWEEN 30.2 AND 40.1 THEN 3
            WHEN grn_hon_count BETWEEN 40.2 AND 50.1 THEN 4
            WHEN grn_hon_count BETWEEN 50.2 AND 60.1 THEN 5
            WHEN grn_hon_count BETWEEN 60.2 AND 70.1 THEN 6
            WHEN grn_hon_count BETWEEN 70.2 AND 80.1 THEN 7
            WHEN grn_hon_count BETWEEN 80.2 AND 90.1 THEN 8
            WHEN grn_hon_count BETWEEN 90.2 AND 100.1 THEN 9
            WHEN gi.grn_hon_count BETWEEN 100.2 AND 200 THEN 10
          END`;
      // Execute the query
      let gradeSumResult = await manager.query(gradeSumQuery);
      // Filter out records where honCount is null
      gradeSumResult = gradeSumResult.filter(record => record.honCount !== null);

      let honQtyQry = `SELECT SUM(grn_hon_quantity) AS total_grn_hon_quantity,
        CASE 
        WHEN grn_hon_count BETWEEN 0 AND 20 THEN 'upto20'
                WHEN grn_hon_count BETWEEN 20 AND 30 THEN '21-30'
                WHEN grn_hon_count BETWEEN 30 AND 40 THEN '31-40'
                WHEN grn_hon_count BETWEEN 40 AND 50 THEN '41-50'
                WHEN grn_hon_count BETWEEN 50 AND 60 THEN '51-60'
                WHEN grn_hon_count BETWEEN 60 AND 70 THEN '61-70'
                WHEN grn_hon_count BETWEEN 70 AND 80 THEN '71-80'
                WHEN grn_hon_count BETWEEN 80 AND 90 THEN '81-90'
                WHEN grn_hon_count BETWEEN 90 AND 100 THEN '91-100'
                WHEN grn_hon_count BETWEEN 100 AND 200 THEN '101-200'
        END AS grn_hon_count
        
        FROM
        (
        SELECT grn_hon_quantity,grn_hon_count,grade_inventory.lot_number FROM grade_inventory 
        LEFT JOIN erpx_dev_production.grade_inventory_log gl 
            ON gl.lot_number = grade_inventory.lot_number AND gl.grade = grade_inventory.grade
        WHERE DATE(gl.date) BETWEEN '${req.fromDate}' AND '${req.toDate}' 
        GROUP BY lot_number,grn_hon_count ORDER BY grn_hon_count 
        )AS subqury
        GROUP BY 
        CASE
        WHEN grn_hon_count BETWEEN 0 AND 20 THEN 'upto20'
                WHEN grn_hon_count BETWEEN 20 AND 30 THEN '21-30'
                WHEN grn_hon_count BETWEEN 30 AND 40 THEN '31-40'
                WHEN grn_hon_count BETWEEN 40 AND 50 THEN '41-50'
                WHEN grn_hon_count BETWEEN 50 AND 60 THEN '51-60'
                WHEN grn_hon_count BETWEEN 60 AND 70 THEN '61-70'
                WHEN grn_hon_count BETWEEN 70 AND 80 THEN '71-80'
                WHEN grn_hon_count BETWEEN 80 AND 90 THEN '81-90'
                WHEN grn_hon_count BETWEEN 90 AND 100 THEN '91-100'
                WHEN grn_hon_count BETWEEN 100 AND 200 THEN '101-200'
        END`
        const grnHonQtyInfo = await manager.query(honQtyQry)
        const honQtyMap = new Map<string,number>()

        for(const rec of grnHonQtyInfo){
            if(!(honQtyMap.has(rec.grn_hon_count))){
                honQtyMap.set(rec.grn_hon_count,rec.total_grn_hon_quantity)
            }
        }

    //   let subQry = `SELECT 
    //             CASE
    //                 WHEN grn_hon_count BETWEEN 0 AND 20 THEN 'upto20'
    //                 WHEN grn_hon_count BETWEEN 21 AND 30 THEN '21-30'
    //                 WHEN grn_hon_count BETWEEN 31 AND 40 THEN '31-40'
    //                 WHEN grn_hon_count BETWEEN 41 AND 50 THEN '41-50'
    //                 WHEN grn_hon_count BETWEEN 51 AND 60 THEN '51-60'
    //                 WHEN grn_hon_count BETWEEN 61 AND 70 THEN '61-70'
    //                 WHEN grn_hon_count BETWEEN 71 AND 80 THEN '71-80'
    //                 WHEN grn_hon_count BETWEEN 81 AND 90 THEN '81-90'
    //                 WHEN grn_hon_count BETWEEN 91 AND 100 THEN '91-100'
    //             END AS count_range,
    //             MAX(grn_hon_quantity) AS max_quantity
    //         FROM 
    //             grade_inventory WHERE grade_inv_id > 0`
    
    //     if (req.fromDate && req.toDate) {
    //         subQry += ` AND created_at BETWEEN '${req.fromDate} 00:00:00' AND '${req.toDate} 23:59:59'`;
    //     }
    //     subQry += `  GROUP BY count_range, grn_hon_count`
    //   const honQtyQry =  `SELECT count_range, SUM(max_quantity) AS total_quantity FROM (${subQry}) AS range_quantities GROUP BY count_range;`
            // const honQtyInfo = await manager.query(honQtyQry)
          
            // console.log(honQtyInfo,'=======')
            // console.log(gradeSumResult,'gradeSumResult---------------')

      // Return the result based on data presence
      if (gradeSumResult.length > 0) {
        for(const rec of gradeSumResult){
            const honQty = honQtyMap.get(rec.honCount) != undefined ? honQtyMap.get(rec.honCount) : 0
            rec.honQuantity = honQty
        }
        return new CommonResponse(true, 1, 'Data retrieved successfully', gradeSumResult);
      } else {
        return new CommonResponse(false, 0, 'No data found', []);
      }
    } catch (err) {
      throw new Error(`Error retrieving grading summary report: ${err.message}`);
    }
}

  
  async getLotNumbersAgainistGradeRange(req:BillNumberRequest): Promise<CommonResponse>{
    try{
        const manager = getManager();
        let query = `SELECT 
    GROUP_CONCAT(plant_lot_number) AS lotNumber,
    g.reweighment_bill_to,
    MIN(gi.plant_lot_number) AS first_lot_number,
    MAX(gi.plant_lot_number) AS last_lot_number,
    MIN(pgi.created_at) AS firstDate,
    MAX(pgi.created_at) AS lastDate
    FROM erpx_dev_production.grade_inventory pgi
    LEFT JOIN ${appSettings.rm_procure_db}. grn_items gi ON pgi.lot_number = gi.plant_lot_number
    left join ${appSettings.production_db} .grade_inventory_log gl on gl.lot_number = pgi.lot_number and gl.grade = pgi.grade
    LEFT JOIN   ${appSettings.rm_procure_db}.grn g ON g.grn_id = gi.grn_id
    where 1 = 1
    `
    if (req.fromDate && req.toDate) {
        query += `
        AND DATE(gl.date) BETWEEN '${req.fromDate}' AND '${req.toDate}'`;
    }

    query += ` GROUP BY g.reweighment_bill_to`
    const result = await manager.query(query)
    if(result.length>0){
        return new CommonResponse(true,1,'Data retrieved sucessfully',result)
    }else{
        return new CommonResponse(false, 0,'No data found',[])

    }

    }catch(err){
        throw(err)
      }
  }

  
  async updateHonInfoInGradeInv():Promise<CommonResponse>{
    // const manager = getManager()
    // console.log('---------started-----------------')
    const connection = getConnection();
    const transactionManager: QueryRunner = connection.createQueryRunner();
    try{
        await  transactionManager.startTransaction()
        // const getHonQtyQry =  `SELECT IF(reweighment_quantity > 0 , SUM(reweighment_quantity),SUM(quantity)) AS quantity,main_batch_num FROM ${appSettings.rm_procure_db} .grn_items WHERE main_batch_num = '${mainLot}' AND year = ${year} GROUP BY main_batch_num`
        const getHonQtyQry = `SELECT SUM(quantity) AS quantity,IF(lot_club_status = 1, clubbed_main_lot,lot_number) as main_batch_num,count,price FROM ${appSettings.production_db} .lot_code_data 
        GROUP BY IF(lot_club_status = 1, clubbed_main_lot,lot_number)`
        const getHonQty = await transactionManager.query(getHonQtyQry)
        const honQtyMap = new Map<string,any>()
        for(const rec of getHonQty){
            if(!honQtyMap.has(rec.main_batch_num)){
                honQtyMap.set(rec.main_batch_num,rec)
            }
        }
        const getGradedQtyQry = `SELECT SUM(quantity) AS qty,lot_number as main_lot FROM ${appSettings.production_db} .grade_inventory 
        GROUP BY lot_number`
        const getGradedQty = await transactionManager.query(getGradedQtyQry)
        const gradedQtyMap = new Map<string,any>()
        for(const rec of getGradedQty){
            if(!gradedQtyMap.has(rec.main_lot)){
                gradedQtyMap.set(rec.main_lot,rec)
            }
        }

        const getHarvestTypeQuery = `SELECT harvest_type,plant_lot_number as main_batch_num FROM ${appSettings.rm_procure_db} .indent i LEFT JOIN ${appSettings.rm_procure_db} .grn_items gi ON gi.indent_id = i.indent_id 
        `
        const getHarvestType = await transactionManager.query(getHarvestTypeQuery)
        const harvestMap = new Map<string,any>()
        for(const rec of getHarvestType){
            if(!harvestMap.has(rec.main_batch_num)){
                harvestMap.set(rec.main_batch_num,rec)
            }
        }

        const getRmRateQuery = `select count,price,type from ${appSettings.rm_procure_db} .rm_rates where category = '${CompanyCategoryEnum.OWN}'`
        const getRmRate = await transactionManager.query(getRmRateQuery)

        let refObj
        const rmRatesMap = new Map<any,any>()
        for(const rec of getRmRate){
            if(!rmRatesMap.has({count:rec.count,harvestType:rec.type})){
                refObj = JSON.stringify({count:rec.count,harvestType:rec.type})
                rmRatesMap.set(refObj,{count:rec.count,price:rec.price})
            }
        }

        const gradeInfoQry =   `SELECT * from ${appSettings.production_db} .grade_inventory
        `
        const gradeInfo = await transactionManager.query(gradeInfoQry)

        const saveFlag = new Set<boolean>()
        let yieldPer

        for(const rec of gradeInfo){
            console.log(rec,'===============rec')
            const harvestType = harvestMap.get(rec.lot_number).harvest_type
            const gradedQty = gradedQtyMap.get(rec.lot_number).qty
            const honQty = honQtyMap.get(rec.lot_number).quantity
            console.log(honQty,'======================honqty')
            yieldPer = ((Number(gradedQty)) / Number(honQty)) * 100
            const calhonCount = Number((Number(1000/((454/Number(rec.grade)/(yieldPer))*100))).toFixed(1))
            const calHonQty = ((Number(rec.quantity)) / (yieldPer))* 100
            let rmRate
            if(rmRatesMap.get(JSON.stringify({count:Number(calhonCount),harvestType:harvestType})) == undefined){
                let decimalIndex = calhonCount.toString().indexOf(".");
                let afterDecimalValue = calhonCount.toString().substring(decimalIndex+1);
                let beforeDecimalValue = calhonCount.toString().substring(0,decimalIndex);
                const newrefObj = JSON.stringify({count:Number(beforeDecimalValue),harvestType:harvestType})
                const lowerRefObj = JSON.stringify({count:Number(beforeDecimalValue)+1,harvestType:harvestType})
                const upperCountObj = rmRatesMap.get(newrefObj)
                const lowerCountObj = rmRatesMap.get(lowerRefObj)
                if(calhonCount <= 40){
                    if(Number(afterDecimalValue) <= 3){
                        if(upperCountObj == undefined){
                            saveFlag.add(false)
                            await transactionManager.rollbackTransaction()
                            await transactionManager.release()
                            return new CommonResponse(false,0,`RM rate not found for HON count ${calhonCount}`)
                        }else{
                            rmRate = upperCountObj.price
                          }
                    }else if(Number(afterDecimalValue) == 4 || Number(afterDecimalValue) == 5 || Number(afterDecimalValue) ==6){
                    
                        if(lowerCountObj != undefined && upperCountObj != undefined){
                          const diff = Number(upperCountObj.price) - Number(lowerCountObj.price)
                          const halfdiff = Number(diff)/2
                          rmRate = Number(upperCountObj.price) + Math.abs(Number(halfdiff))
                        }else{
                            saveFlag.add(false)
                            await transactionManager.rollbackTransaction()
                            await transactionManager.release()
                            return new CommonResponse(false,0,`RM rate not found for HON count ${calhonCount}`)
                        }
                    }else{
                        if(lowerCountObj == undefined){
                            saveFlag.add(false)
                          await transactionManager.rollbackTransaction()
                        await transactionManager.release()
                           return new CommonResponse(false,0,`RM rate not found for HON count ${calhonCount}`)
                        }else{
                          rmRate = lowerCountObj.price
                        }
                      }

                }else{
                    if(Number(afterDecimalValue) <= 3){
                      if(upperCountObj == undefined){
                        saveFlag.add(false)
                        await transactionManager.rollbackTransaction()
                        await transactionManager.release()
                        return new CommonResponse(false,0,`RM rate not found for HON count ${calhonCount}`)
                      }else{
                        rmRate = upperCountObj.price
                      }
                    }else if(Number(afterDecimalValue) == 4 || Number(afterDecimalValue) == 5){
                      if(lowerCountObj != undefined && upperCountObj != undefined){
                        const diff = Number(upperCountObj.price) - Number(lowerCountObj.price)
                        const halfdiff = Number(diff)/2
                        rmRate = Number(upperCountObj.price) + Math.abs(Number(halfdiff))
                      }else{
                        saveFlag.add(false)
                        await transactionManager.rollbackTransaction()
                        await transactionManager.release()
                        return new CommonResponse(false,0,`RM rate not found for HON count ${calhonCount}`)
                      }
                    }else{
                      if(lowerCountObj == undefined){
                        saveFlag.add(false)
                        await transactionManager.rollbackTransaction()
                        await transactionManager.release()
                        return new CommonResponse(false,0,`RM rate not found for HON count ${calhonCount}`)
                      }else{
                        rmRate = lowerCountObj.price
                      }
                    }
                }
            }else{
                rmRate = rmRatesMap.get(JSON.stringify({count:Number(calhonCount),harvestType:harvestType})).price
            }

            const calrmRate = rmRate
            const amount =  Number(((Number(rec.quantity)) / (yieldPer))* 100) * Number(rmRate)
            if(rmRate > 0){
                const updateInfo = await transactionManager.manager.update(GradeInventory,{gradeInvId:rec.grade_inv_id},{honCount:calhonCount,honQuantity:calHonQty,rmRate:calrmRate,amount:amount,grnHonCount:honQtyMap.get(rec.lot_number).count,grnHonQuantity:honQty,grnRmRate:honQtyMap.get(rec.lot_number).price})
                if(!updateInfo){
                    saveFlag.add(false)
                    await transactionManager.rollbackTransaction()
                    await transactionManager.release()
                    return new CommonResponse(false,0,'Something went wrong in updating cal HON info')
                }

            }

            const updateYieldPer = await this.rmGrnService.updateYieldPer(new YieldPerReq(rec.lot_number,yieldPer,rec.year))
            if(!updateYieldPer.status){
                await transactionManager.rollbackTransaction()
                await transactionManager.release()
                return new CommonResponse(false,0,'Something went wrong in updating yield percentage')
            }
        }
        if(!(saveFlag.has(false))){
             
            await transactionManager.commitTransaction()
            await transactionManager.release()
            return new CommonResponse(true,1,'Updated successfully')
        }else{
            await transactionManager.rollbackTransaction()
            await transactionManager.release()
            return new CommonResponse(false,0,'Something went wrong')
        }
        }catch(err){
            console.log(err,'==')
            await transactionManager.rollbackTransaction()
            await transactionManager.release()
            return new CommonResponse(false,0,'Something went wrong')
        }
    }

    async updateRatesAgainstIndentDate():Promise<CommonResponse>{
        const connection = getConnection();
        const transManager: QueryRunner = connection.createQueryRunner();
        try{
            const saveFlag = new Set<boolean>()
            await transManager.startTransaction()
            const getGradeInfoQry = `SELECT g.grade_inv_id,g.hon_count,i.indent_date,i.harvest_type,i.indent_id,g.hon_quantity,gi.price from ${appSettings.production_db} .grade_inventory g
            LEFT JOIN ${appSettings.rm_procure_db} .grn_items gi on gi.plant_lot_number = g.lot_number and g.year=gi.year 
            LEFT JOIN ${appSettings.production_db} .grade_inventory_log gil on g.lot_number = gil.lot_number and g.year=gil.year AND g.grade = gil.grade
            LEFT JOIN ${appSettings.rm_procure_db} .indent i on i.indent_id = gi.indent_id where date(gil.date) between '2025-03-27' and '2025-04-08'`
            const gradesInfo = await transManager.query(getGradeInfoQry)

            if(gradesInfo.length > 0){
                for(const rec of gradesInfo){
                    const getRefCountQry = `SELECT reference_count as count FROM ${appSettings.rm_procure_db} .half_count_ranges WHERE min_count <= ${Number(rec.hon_count)} AND max_count >= ${Number(rec.hon_count)}`
                    const referenceCount = await transManager.query(getRefCountQry)
                    if(referenceCount.length > 0){
                        const req = new RmRatesInfoReq(rec.indent_id,rec.harvest_type,CompanyCategoryEnum.OWN,Number(rec.hon_count),rec.indent_date)
                        const getRmRateInfo = await this.rmCountPriceListService.getRmRatesAgainstUploadedDate(req)
                        if(getRmRateInfo.status){
                            const update = await transManager.manager.getRepository(GradeInventory).update({gradeInvId:rec.grade_inv_id},{rmRate:getRmRateInfo.data[0].price,amount:(getRmRateInfo.data[0].price)*(rec.hon_quantity),grnRmRate:rec.price,priceCount:referenceCount[0].count})
                            if(update.affected){
                                saveFlag.add(true)
                            }else{
                                saveFlag.add(false)
                                await transManager.rollbackTransaction()
                                await transManager.release()
                                return new CommonResponse(false,0,'Something went wrong in updating price')
                            }
                        }else{
                            await transManager.rollbackTransaction()
                            await transManager.release()
                            return new CommonResponse(false,0,`Rm rate not found for the count ${referenceCount[0].count}`)
                        }
                    }
                }
                if(!(saveFlag.has(false))){
                    await transManager.commitTransaction()
                    await transManager.release()
                    return new CommonResponse(false,0,'successfull')
                }else{
                    await transManager.rollbackTransaction()
                    await transManager.release()
                    return new CommonResponse(false,0,'Something went wrong')
                }
            }
        }catch(err){
            await transManager.rollbackTransaction()
            await transManager.release()
            return new CommonResponse(false,0,'Something went wrong')
        }
    }

  
  
}

    


